<template>
  <div> 
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Enquiry & Sales Quotation Details</b-navbar-brand>
          <!-- <b-button 
              size="sm" 
              text="Lock & Un-Lock Panel" 
              class="ml-2"
              variant="outline-info"
              @click="viewAllQuotationLibrary()"
            >Quotation Library</b-button> -->
        </b-navbar>
        <FilterCBModal />
        <!-- <div class="gutr"
         v-if="$sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh'"
        >
                <b-button
                  size="sm"
                  class="pull-right"
                  @click="goToMisc"
                  variant="primary"
                >New Misc Job</b-button>
      
          </div>
          <br>
          <br> -->

        <div>
          <!-- Using modifiers -->
          <!-- <b-button
            variant="outline-dark"
            :class="visible ? null : 'collapsed'"
            :aria-expanded="visible ? 'true' : 'false'"
            aria-controls="collapse-4"
            @click="visible = !visible"
          >Filters</b-button>-->
          <b-collapse v-model="visible" id="collapse-2">
            <b-card>
              <b-row>
                 <b-col md="4" class="mt-1 mb-1">
                  <date-range-picker :opens="openLeft" :always-show-calendars="showCal" v-model="dateRange"
                    :startDate="startDate" :endDate="endDate" :locale-data="locale" />
                 
                </b-col>
                <b-col md="4" class="mt-1 mb-1">
                  <model-list-select
                    :list="clientTypeList"
                    id="clientNamenew"
                    v-model="clientTypeFilter"
                    option-value="val"
                    option-text="type"
                    placeholder="Client Type"
                  ></model-list-select>
                </b-col>
                <b-col md="4" class="mt-1 mb-1" v-if="clientTypeFilter !='2'" >
                  <model-list-select
                    :list="clientMaster"
                    id="clientNamenew"
                    v-model="clientIdFilter"
                    option-value="clientId"
                    option-text="clientName"
                    placeholder="Select  Client Name"
                  ></model-list-select>
                </b-col>
                <b-col md="4" class="mt-1 mb-1" v-if="clientTypeFilter !='1'" >
                  <model-list-select
                    :list="$store.getters['common/getAllLeadCompList']"
                    id="leadIdFilter"
                    v-model="leadIdFilter"
                    option-value="lead_id"
                    option-text="lead_comp_name"
                    placeholder="Select Lead Name"
                  ></model-list-select>
                </b-col>
                <b-col md="4" class="mt-1 mb-1" v-if="clientTypeFilter !='0'" >
                  <model-list-select
                    :list="shipmentTypeList"
                    v-model="shipmentTypeFilter"
                    option-value="shipmentTypeVal"
                    option-text="shipmentTypeText"
                    placeholder="Select Sea / Air"
                  ></model-list-select>
                </b-col>
                <b-col md="4" class="mt-1 mb-1" v-if="clientTypeFilter !='2' && clientTypeFilter !='1'">
                  <b-row>
                    <b-col md="6">
                      <model-list-select
                        :list="shipmentTypeList"
                        v-model="shipmentTypeFilter"
                        option-value="shipmentTypeVal"
                        option-text="shipmentTypeText"
                        placeholder="Select Sea / Air"
                      ></model-list-select>
                    </b-col>
                    <b-col md="6">
                      <model-list-select
                        :list="flTypeList"
                        v-model="fclLclFilter"
                        option-value="flVal"
                        option-text="flText"
                        placeholder="Select FCL / LCL"
                      ></model-list-select>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="4" class="mt-1 mb-1" v-else>
                  <model-list-select
                    :list="flTypeList"
                    v-model="fclLclFilter"
                    option-value="flVal"
                    option-text="flText"
                    placeholder="Select FCL / LCL"
                  ></model-list-select>
                </b-col>
                <b-col md="4" class="mt-1 mb-1">
                  <model-list-select
                    :list="transportTypeName"
                    v-model="transportTypeFilter"
                    option-value="transportTypeVal"
                    option-text="transportTypeText"
                    placeholder="Select Export / Import"
                  ></model-list-select>
                </b-col>
                <b-col md="4" class="mt-1 mb-1">
                  <model-list-select
                    @input="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                    :list="finalAllPlaceDataPOR"
                    v-model="PORfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Place of Receipt"
                  ></model-list-select>
                </b-col>
                <b-col md="4" class="mt-1 mb-1">
                  <model-list-select
                    @input="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                    :list="finalAllPlaceDataPOD"
                    v-model="PODfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Port of Discharge"
                  ></model-list-select>
                </b-col>
                <b-col md="4" class="mt-1 mb-1">
                  <model-list-select
                    @input="getLocationList($event, 'All', 'finalAllPlaceDataLP')"
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataLP')"
                    :list="finalAllPlaceDataLP"
                    v-model="LPfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Load Port"
                  ></model-list-select>
                </b-col>
                <b-col md="4" class="mt-1 mb-1">
                  <model-list-select
                    :list="containerList"
                    v-model="containerFilter"
                    option-value="containerTypeId"
                    option-text="containerType"
                    placeholder="Select Container Type"
                  ></model-list-select>
                </b-col>
                <b-col md="4" class="mt-1 mb-1">
                  <model-list-select
                    :list="shippingList"
                    v-model="shippingFilter"
                    option-value="shippingId"
                    option-text="shippingLine"
                    placeholder="Select Shipping Line"
                  ></model-list-select>
                </b-col>
                <b-col md="4" class="mt-1 mb-1">
                  <b-form-input
                    :formatter="capitalizeAll"
                    placeholder="Search Enquiry"
                    id="newClientName"
                    name="newClientName"
                    v-model="enquiryFilter"
                  ></b-form-input>
                </b-col>
                <b-col md="4" class="mt-1 mb-1">
                  <b-form-input
                    :formatter="capitalizeAll"
                    placeholder="Search  Quotation"
                    id="newClientName"
                    name="newClientName"
                    v-model="ffQuoteFilter"
                  ></b-form-input>
                </b-col>
                <b-col md="4" class="mt-1 mb-1">
                  <model-list-select
                    :list="$store.getters['commonDropdownMaster/getAllPickupList']"
                    v-model="PickupLocfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Pickup Location"
                  ></model-list-select>
                </b-col>
                <b-col md="4" class="mt-1 mb-1">
                  <model-list-select
                    :list="$store.getters['commonDropdownMaster/getAllHandoverList']"
                    v-model="HANDfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Handover Location"
                  ></model-list-select>
                </b-col>
                <b-col md="4" class="mt-1 mb-1">
                  <model-list-select
                    :list="$store.getters['commonDropdownMaster/getAllStuffingList']"
                    v-model="STUFFfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Stuffing Location"
                  ></model-list-select>
                </b-col>
              </b-row>
              <!-- <md-layout md-gutter class="mt-3 justify-content-center">
                <md-layout md-flex="35" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    :list="clientTypeList"
                    id="clientNamenew"
                    v-model="clientTypeFilter"
                    option-value="val"
                    option-text="type"
                    placeholder="Client Type"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="35" v-if="clientTypeFilter !='2'" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    :list="clientMaster"
                    id="clientNamenew"
                    v-model="clientIdFilter"
                    option-value="clientId"
                    option-text="clientName"
                    placeholder="Select  Client Name"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="35" v-if="clientTypeFilter !='1'" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    :list="$store.getters['common/getAllLeadCompList']"
                    id="leadIdFilter"
                    v-model="leadIdFilter"
                    option-value="lead_id"
                    option-text="lead_comp_name"
                    placeholder="Select Lead Name"
                  ></model-list-select>
                </md-layout> -->
                <!-- <md-layout md-flex="20" md-flex-small="100">
                  <model-list-select
                    :list="jTypeList"
                    v-model="jobTypeFilter"
                    option-value="jTypeVal"
                    option-text="jTypeText"
                    placeholder="Select Job Type "
                  ></model-list-select>
                </md-layout>-->
                <!-- <md-layout md-flex="5"></md-layout> -->
                <!-- <md-layout md-flex="30" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    :list="shipmentTypeList"
                    v-model="shipmentTypeFilter"
                    option-value="shipmentTypeVal"
                    option-text="shipmentTypeText"
                    placeholder="Select Sea / Air"
                  ></model-list-select>
                </md-layout>
              </md-layout> -->
              <!-- <md-layout md-gutter class="mt-3 justify-content-center">
                <md-layout md-flex="35" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    :list="flTypeList"
                    v-model="fclLclFilter"
                    option-value="flVal"
                    option-text="flText"
                    placeholder="Select FCL / LCL"
                  ></model-list-select>
                </md-layout> -->
                <!-- <md-layout md-flex="5"></md-layout> -->
                <!-- <md-layout md-flex="35" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    :list="transportTypeName"
                    v-model="transportTypeFilter"
                    option-value="transportTypeVal"
                    option-text="transportTypeText"
                    placeholder="Select Export / Import"
                  ></model-list-select>
                </md-layout> -->
                <!-- <md-layout md-flex="5"></md-layout> -->
                <!-- <md-layout md-flex="30" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    @input="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                    :list="finalAllPlaceDataPOR"
                    v-model="PORfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Place of Receipt"
                  ></model-list-select>
                </md-layout>
              </md-layout> -->
              <!-- <md-layout md-gutter class="mt-3 justify-content-center">
                <md-layout md-flex="35" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    @input="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                    :list="finalAllPlaceDataPOD"
                    v-model="PODfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Port of Discharge"
                  ></model-list-select>
                </md-layout> -->
                 <!-- <md-layout md-flex="5"></md-layout> -->
                <!-- <md-layout md-flex="35" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    @input="getLocationList($event, 'All', 'finalAllPlaceDataLP')"
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataLP')"
                    :list="finalAllPlaceDataLP"
                    v-model="LPfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Load Port"
                  ></model-list-select>
                </md-layout> -->

                <!-- <md-layout md-flex="5"></md-layout> -->
                <!-- <md-layout md-flex="30" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    :list="containerList"
                    v-model="containerFilter"
                    option-value="containerTypeId"
                    option-text="containerType"
                    placeholder="Select Container Type"
                  ></model-list-select>
                </md-layout> -->

                <!-- <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="30">
                      <model-list-select
                        :list="airlineList"
                        v-model="airlineFilter"
                        option-value="airlineId"
                        option-text="airlineName"
                        placeholder="Select Airline "
                      ></model-list-select>
                </md-layout>-->
              <!-- </md-layout> -->
              <!-- <md-layout md-gutter class="mt-3 justify-content-center">
                <md-layout md-flex="35" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    :list="shippingList"
                    v-model="shippingFilter"
                    option-value="shippingId"
                    option-text="shippingLine"
                    placeholder="Select Shipping Line"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="35" class="pl-2 pr-2" md-flex-small="100">
                  <b-form-input
                    :formatter="capitalizeAll"
                    placeholder="Search Enquiry"
                    id="newClientName"
                    name="newClientName"
                    v-model="enquiryFilter"
                  ></b-form-input>
                </md-layout>
                <md-layout md-flex="30" class="pl-2 pr-2" md-flex-small="100">
                  <b-form-input
                    :formatter="capitalizeAll"
                    placeholder="Search  Quotation"
                    id="newClientName"
                    name="newClientName"
                    v-model="ffQuoteFilter"
                  ></b-form-input>
                </md-layout> -->
                <!-- <md-layout md-flex="35" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    @input="
                      getLocationList(
                        $event,
                        'Icd,Sea_Port_India',
                        'finalAllPlaceDataPickupLocation'
                      )
                    "
                    @searchchange="
                      getLocationList(
                        $event,
                        'Icd,Sea_Port_India',
                        'finalAllPlaceDataPickupLocation'
                      )
                    "
                    :list="finalAllPlaceDataPickupLocation"
                    v-model="PickupLocfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Pickup Location"
                  ></model-list-select>
                </md-layout> -->
                <!-- <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30">
                  <b-form-input :formatter="capitalizeAll"
                    placeholder="Search CC Quote"
                    id="newClientName"
                    name="newClientName"
                    v-model="ccQuoteFilter"
                  ></b-form-input>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30">
                  <b-form-input :formatter="capitalizeAll"
                    placeholder="Search TPT Quote"
                    id="newClientName"
                    name="newClientName"
                    v-model="tptQuoteFilter"
                  ></b-form-input>
                </md-layout>-->
              <!-- </md-layout> -->
              <!-- <md-layout md-gutter class="mt-3 justify-content-center">
                <md-layout md-flex="35" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    :list="$store.getters['commonDropdownMaster/getAllPickupList']"
                    v-model="PickupLocfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Pickup Location"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="35" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    :list="$store.getters['commonDropdownMaster/getAllHandoverList']"
                    v-model="HANDfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Handover Location"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="30" class="pl-2 pr-2" md-flex-small="100">
                  <model-list-select
                    :list="$store.getters['commonDropdownMaster/getAllStuffingList']"
                    v-model="STUFFfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Stuffing Location"
                  ></model-list-select>
                </md-layout>
              </md-layout> -->
              <b-row class="mt-3 justify-content-center">
                <b-col cols="6" class="text-center">
                  <b-button size="sm" @click="filterSearch" variant="outline-primary"
                    >Search</b-button
                  >
                  <b-button
                    class="ml-3"
                    size="sm"
                    @click="clearFilter"
                    variant="outline-info"
                    >clear</b-button
                  >
                </b-col>
              </b-row>
            </b-card>
          </b-collapse>
        </div>

        <b-row class="mt-2">
          <b-col>
            <b-button
              variant="outline-dark"
              :class="visible ? null : 'collapsed'"
              :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4"
              @click="visible = !visible"
              >Filters</b-button
            >
          </b-col>
          <b-col>
            <h5 class="text-muted pull-right" style="margin-bottom: 0 !important">
              <small v-if="isLoading == false">{{ totalRows }} Entries</small>
            </h5>
          </b-col>
        </b-row>

        <div class="table-responsive tableMain mt-2">
          <b-table
            show-empty
            stacked="md"
            responsive
            :items="consoBooking"
            :fields="fields"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
          >
            <template slot="mainEnquiryId" slot-scope="row0">
              <span
                >{{ row0.index + 1 + (currentPage - 1) * perPage }}
                <md-icon>{{
                  row0.item.shipmentType == "1" ? "directions_boat" : "flight_takeoff"
                }}</md-icon></span
              >
            </template>
            <template slot="mainEnquirySeries" slot-scope="row1">
              
              <b
                @click="viewExportFCLConPage(row1.item.mainEnquiryId)"
                class="showMoreData"
                >{{ row1.item.mainEnquirySeries }}</b
              >
              <br />
              <span
                >Enquiry Type : {{ row1.item.jobType }} ({{
                  row1.item.shipmentType == "1" ? "Sea" : "Air"
                }}
                {{ row1.item.transportType }}) - {{ row1.item.containerInfo }}</span
              >
              <br />
              <span>Enquiry Date : {{ row1.item.loginTime | moment }}</span>
              <br />
              <span>Raised From : {{ row1.item.EmpLoc }}</span>
              <br />
              <span>Raised By : {{ row1.item.employeeName }}</span>
              <br />
              <b-badge
                variant="danger"
                v-if="
                  (row1.item.ccStatus == '0' && row1.item.managerApproveCC == '1') ||
                  (row1.item.tptStatus == '0' && row1.item.managerApproveTPT == '1') ||
                  (row1.item.ffStatus == '0' && row1.item.managerApproveFF == '1')
                "
                >Client Approval Pending</b-badge
              >
              <b-button
                v-if="$sessionsStorage.get('nameUser') == 'Bhavneesh' && $sessionsStorage.get('designation') == 'Admin'"
                style="font-size: 11px"
                @click="EnquiryMultiUpdate(row1.item)"
                size="sm"
                class="mt-1"
                variant="outline-info"
                :disabled="$sessionsStorage.get('nameUser') == 'Bhavneesh' && $sessionsStorage.get('designation') == 'Admin'?false:true"
                ><b>Add Service</b></b-button>
                <b-button
                v-if="($sessionsStorage.get('is_access_multi_update')=='1' || ($sessionsStorage.get('nameUser') == 'Bhavneesh' && $sessionsStorage.get('designation') == 'Admin'))"
                style="font-size: 11px"
                @click="MultiUpdate(row1.item)"
                size="sm"
                class="mt-1"
                variant="outline-info"
                :disabled="row1.item.jobType.indexOf('TPT')>= 0?false:true"
                ><b>Multi-Update</b></b-button>
            </template>

            <template slot="clientName" slot-scope="row11">
              <b>
                {{ row11.item.clientName }}
                
                <br />
                <b-badge v-if="row11.item.clientTypeFilter == '3'">Overseas Agent</b-badge>
              </b>
              <b v-if='row11.item.client_type_status'>Type : {{row11.item.client_type_status}}</b>
            </template>

            <!-- <template slot="loginTime" slot-scope="row5">
                <span>{{row5.item.loginTime}}</span>
              </template>-->
            <template slot="PORlocationId" slot-scope="row7">
              <span
                v-if="
                  row7.item.multipleContainerType != '' &&
                  row7.item.multipleContainerType != null
                "
              >
                Container Type : {{ row7.item.multipleContainerType }}
                <br />
              </span>

              <span v-if="row7.item.shippingLine != '' && row7.item.shippingLine != null">
                Prefered Shipping Line : {{ row7.item.shippingLine }}
                <br />
              </span>

              <span v-if="row7.item.pickup != '' && row7.item.pickup != null">
                Pickup : {{ row7.item.pickup }}
                <br />
              </span>

              <span v-if="row7.item.stuffingLoc != '' && row7.item.stuffingLoc != null">
                Stuffing : {{ row7.item.stuffingLoc }}
                <br />
              </span>

              <span v-if="row7.item.handover != '' && row7.item.handover != null">
                Handover : {{ row7.item.handover }}
                <br />
              </span>

              <span v-if="row7.item.POR != '' && row7.item.POR != null">
                Place of Receipt : {{ row7.item.POR }}
                <br />
              </span>

              <div v-if="row7.item.jobType && String(row7.item.jobType).split(',').includes('FF')">
                <span v-if="row7.item.LP != '' && row7.item.LP != null">
                  Load Port : {{ row7.item.LP }}
                  <br />
                </span>
                <span
                  v-if="
                    row7.item.ApprovedSLine != '' &&
                    row7.item.shipmentType == '1' &&
                    row7.item.ApprovedSLine != null
                  "
                >
                  Approved Shipping Line : {{ row7.item.ApprovedSLine }}
                  <br />
                </span>
                <span v-if="row7.item.POD != '' && row7.item.POD != null">
                  Port of Discharge : {{ row7.item.POD }}
                  <br />
                </span>

                <span v-if="row7.item.finalPlace != '' && row7.item.finalPlace != null">
                  Final Place of Delivery : {{ row7.item.finalPlace }}
                  <br />
                </span>
                <span
                  v-if="row7.item.departAirport != '' && row7.item.departAirport != null"
                >
                  Departure Airport : {{ row7.item.departAirport }}
                  <br />
                </span>
                <span
                  v-if="row7.item.destiAirport != '' && row7.item.destiAirport != null"
                >
                  Destination Airport : {{ row7.item.destiAirport }}
                  <br />
                </span>
                <span
                  v-if="
                    row7.item.noOfPkg != '' &&
                    row7.item.noOfPkg != null &&
                    row7.item.noOfPkg != '0'
                  "
                >
                  No.of Packages : {{ row7.item.noOfPkg }}
                  <br />
                </span>
                <span
                  v-if="
                    row7.item.cargoReceived != '' &&
                    row7.item.cargoReceived != null &&
                    row7.item.cargoReceived != '0'
                  "
                >
                  Cargo Received At :
                  {{ row7.item.cargoReceived == "1" ? "Airport" : "Warehouse" }}
                  <br />
                </span>
              </div>
              <!-- {{$sessionsStorage
                  .get('finalPagePermision')
                  .split(',')
                  .indexOf('Pricing')}}
                  {{$sessionsStorage.get('userLevel')}} -->
            </template>
            <template
              v-if="$sessionsStorage.get('finalPagePermision').split(',').indexOf('Pricing') >= 0 || $sessionsStorage.get('userLevel') == 1
              "
              slot="ffStatus"
              slot-scope="row6"
            >
              <div>
                <!-- {{row6.item.shipmentType}} -->
                <b-button-group id="hjhjh" vertical>
                  <div >
                    <!-- v-if="row6.item.shipmentType != '2'" -->
                    <b-button
                      style="width: 195px; margin-bottom: 0.5rem"
                      size="sm"
                      v-if="String(row6.item.jobType).split(',').indexOf('TPT') >= 0"
                      @click="goToQuo(row6.item,row6.item.mainEnquiryId)"
                      :variant="
                        row6.item.sendHODApprove != 1
                          ? 'outline-danger'
                          : 'outline-success'
                      "
                    >
                      <span v-if="row6.item.sendHODApprove != 1"
                        >Generate TPT Quotation</span
                      >
                      <span v-else
                        >View TPT Quotation
                        <br />
                        {{ row6.item.tptQSeries }}
                        <br />
                        <b-badge
                          variant="success"
                          v-if="row6.item.tptExistingQuoteUsed != '0'"
                          >Existing Quote Used</b-badge
                        >
                      </span>
                      <span class="error">{{
                        row6.item.tptExpired == 1 ? " (Expired)" : ""
                      }}</span>
                    </b-button>
                  </div>
                  <div>
                    <b-button
                      style="width:195px margin-bottom: 0.5rem;"
                      v-if="String(row6.item.jobType).split(',').indexOf('FF') >= 0"
                      @click="goToFF(row6.item,row6.item.mainEnquiryId)"
                      size="sm"
                      :variant="
                        row6.item.sendHODApproveFF != 1
                          ? 'outline-danger'
                          : 'outline-success'
                      "
                    >
                      <span v-if="row6.item.sendHODApproveFF != 1"
                        >Generate FF Quotation</span
                      >
                      <span v-else
                        >View FF Quotation
                        <br />
                        {{ row6.item.mainFFSeries }}
                        <br />
                        <b-badge
                          variant="success"
                          v-if="row6.item.ffExistingQuoteUsed != '0'"
                          >Existing Quote Used</b-badge
                        >
                      </span>
                      <span class="error">{{
                        row6.item.ffExpired == 1 ? " (Expired)" : ""
                      }}</span>
                    </b-button>
                  </div>
                  <!-- v-if="row6.item.shipmentType != '2'" -->
                  <div >
                    <b-button
                      style="width:195px; margin-bottom: 0.5rem;"
                      v-if="String(row6.item.jobType).split(',').indexOf('CC') >= 0"
                      @click="goToCC(row6.item,row6.item.mainEnquiryId)"
                      size="sm"
                      :variant="
                        row6.item.sendHODApproveCC != 1
                          ? 'outline-danger'
                          : 'outline-success'
                      "
                    >
                      <span v-if="row6.item.sendHODApproveCC != 1"
                        >Generate CC Quotation</span
                      >
                      <span v-else
                        >View CC Quotation
                        <br />
                        {{ row6.item.ccQSeries }}
                        <br />
                        <b-badge
                          variant="success"
                          v-if="row6.item.ccExistingQuoteUsed != '0'"
                          >Existing Quote Used</b-badge
                        >
                      </span>

                      <span class="error">{{
                        row6.item.ccExpired == 1 ? " (Expired)" : ""
                      }}</span>
                    </b-button>
                  </div>
                </b-button-group>
              </div>

              <!-- <div
                  v-if="(row6.item.tptStatus==1 && row6.item.tptExpired==0) || (row6.item.ccStatus==1 && row6.item.ccExpired==0) || (row6.item.ffStatus==1  && row6.item.ffExpired==0)"
                >
                  <b-button
                    style="width:150px"
                    @click="goToExe(row6.item)"
                    variant="primary"
                    size="sm"
                  >Proceed To Execution</b-button>
                </div>-->
            </template>
            <template slot="ffquotation_remark" slot-scope="row8">
              <span v-if="row8.item.ffquotation_remark != ''"
                >FF : {{ row8.item.ffquotation_remark }}<br
              /></span>
              <span v-if="row8.item.ccquotation_remark != ''"
                >CC : {{ row8.item.ccquotation_remark }}<br
              /></span>
              <span v-if="row8.item.tptquotation_remark != ''"
                >TPT : {{ row8.item.tptquotation_remark }}<br
              /></span>
            </template>

            <template slot="tptExpired" slot-scope="row7">
              <div>
                <span
                  class="error"
                  v-if="
                    row7.item.ffQuoteValidity < currentDateValid &&
                    row7.item.ffQuoteValidity != null
                  "
                  >FF Quote Expired
                  <br />
                </span>
                <span
                  class="error"
                  v-if="
                    row7.item.ccQuoteValidity < currentDateValid &&
                    row7.item.ccQuoteValidity != null
                  "
                  >CC Quote Expired
                  <br />
                </span>
                <span
                  class="error"
                  v-if="
                    row7.item.tptQuoteValidity < currentDateValid &&
                    row7.item.tptQuoteValidity != null
                  "
                  >TPT Quote Expired
                  <br />
                </span>
                <b-dropdown
                  v-if="
                    (row7.item.tptQuotationPdf != '' &&
                      row7.item.tptQuotationPdf != null &&
                      row7.item.sendHODApprove == 1) ||
                    (row7.item.ffQuotationPdf != '' &&
                      row7.item.ffQuotationPdf != null &&
                      row7.item.sendHODApproveFF == 1) ||
                    (row7.item.ccQuotationPdf != '' &&
                      row7.item.ccQuotationPdf != null &&
                      row7.item.sendHODApproveCC == 1)
                  "
                  style="width: 150px"
                  variant="success"
                  size="sm"
                  text="Quotation PDF"
                  class="m-2"
                >
                  <b-dropdown-item-button
                    v-if="
                      row7.item.tptQuotationPdf != '' &&
                      row7.item.tptQuotationPdf != null &&
                      row7.item.sendHODApprove == 1
                    "
                    @click="Print2(row7.item.tptQuotationPdf)"
                    >TPT Quotation PDF</b-dropdown-item-button
                  >
                  <b-dropdown-item-button
                    v-if="
                      row7.item.ffQuotationPdf != '' &&
                      row7.item.ffQuotationPdf != null &&
                      row7.item.sendHODApproveFF == 1
                    "
                    @click="Print(row7.item.ffQuotationPdf)"
                    >FF Quotation PDF</b-dropdown-item-button
                  >
                  <b-dropdown-item-button
                    v-if="
                      row7.item.ccQuotationPdf != '' &&
                      row7.item.ccQuotationPdf != null &&
                      row7.item.sendHODApproveCC == 1
                    "
                    @click="Print1(row7.item.ccQuotationPdf)"
                    >CC Quotation PDF</b-dropdown-item-button
                  >
                  <b-dropdown-item-button
                    v-if="
                      row7.item.mergeClientQuotationPdf != '' &&
                      row7.item.mergeClientQuotationPdf != null
                    "
                    @click="PrintConso(row7.item.mergeClientQuotationPdf)"
                    >Consolidated Quote PDF</b-dropdown-item-button
                  >
                </b-dropdown>
              </div>
              <!-- quotation_remark -->
              <!-- {{row7.item}} -->
              <div
                v-if="
                  (row7.item.tptStatus == 1 && row7.item.tptExpired == 0) ||
                  (row7.item.ccStatus == 1 && row7.item.ccExpired == 0) ||
                  (row7.item.ffStatus == 1 && row7.item.ffExpired == 0)
                "
              >
                <b-button
                  style="width: 180px"
                  @click="goToExe(row7.item)"
                  variant="primary"
                  size="sm"
                  >Proceed To Execution</b-button
                >
              </div><br />
              <div>
                <b-button
                  style="width: 180px"
                  @click="showDocModal(row7.item)"
                  variant="primary"
                  size="sm"
                  >Document Upload</b-button
                >
              </div>

              <b-modal
                class="modal-dialog-doc"
                size="xl"
                no-close-on-esc
                no-close-on-backdrop
                ref="doc-modal"
                hide-footer
                :title="'Upload Documents - ' + documentModalSeries "
              >
              
                <h5 class="pull-right text-muted"> {{ documentCount + " Documents" }} </h5>

                <div v-if="documentModalSeries" class="table-responsive tableMain">
                  <table class="table table-sm table-bordered">
                    <tbody style="background: white">
                      <tr>
                        <th scope="col">SN.</th>
                        <th scope="col">Document Name</th>
                        <th scope="col">Document Remarks</th>
                        <th scope="col">Attach Document</th>
                        <th scope="col">Action
                          <b-button
                            class="ml-3"
                            id="show-btn"
                            size="sm"
                            variant="outline-primary"
                            @click="addPortExpenseArray"
                          >
                            Add Document <i class="fa fa-plus ml-1" aria-hidden="true"></i>
                          </b-button>
                        </th>
                      </tr>

                      <tr v-for="(item, idx) in documentModalArr" :key="idx">
                        <th scope="row">{{ idx + 1 }}</th>

                        <td>
                          <b-form-input
                            :formatter="capitalizeAll"
                            name="docName"
                            id="docName"
                            v-model="item.doc_name"
                          ></b-form-input>

                          <span class="error" v-if="item.doc_name_err">
                            {{ item.doc_name_err }}
                          </span>

                          <span class="error" v-if="item.doc_created_date">
                            Added on {{ item.doc_created_date }}
                          </span><br />
                          <span class="error" v-if="item.createdBy || item.updatedBy">
                            Created/Updated By {{ item.createdBy ? item.createdBy : item.updatedBy }}
                          </span><br />
                          
                        </td>

                        <td>
                          <b-form-textarea
                            :formatter="capitalizeAll"
                            id="remark"
                            name="remark"
                            v-model="item.doc_remark"
                          ></b-form-textarea>
                        </td>

                        <td>
                          <Single-Upload
                            :index="idx"
                            :multiple="false"
                            :documentName="'Enq_Doc-'"
                            :otherDocName="'Enq_Doc-'"
                            :folderName="'Enq_Doc'"
                            :accept="'*'"
                            v-model="item.doc_url"
                            :state="Boolean(item.doc_url)"
                            :assign_no="documentModalSeries"
                            :fileAllModuleId="documentModalEnqId"
                          />

                          <span class="error" v-if="item.doc_url_err">
                            {{ item.doc_url_err}}
                          </span><br />
  
                          <a
                            v-if="item.doc_url"
                            href="javascript:void(0)" @click="openSignedDocument(`ASSIGNMENT_UPLOADS/${documentModalSeries.replaceAll('/', '_')}/${item.doc_url.replaceAll('/', '_')}`)"
                            >--View
                          </a>
                        </td>

                        <td>
                          <b-button
                            :disabled="($sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh')?false:true"
                            class="ml-2"
                            id="show-btn"
                            size="sm"
                            variant="danger"
                            style="font-size: 0.675rem"
                            @click="removeInvArry(item, idx)"
                          >
                            Remove Document
                            <i class="fa fa-minus ml-1" aria-hidden="true"></i>
                          </b-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <b-button
                  v-if="documentModalArr.length > 0"
                  class="mt-3 pull-left"
                  variant="primary"
                  id="addButtonLoaderSB"
                  @click="addDocumentDetail"
                >
                  Save & Submit
                </b-button>

                <md-spinner
                  md-indeterminate
                  id="loaderSB"
                  style="display: none"
                ></md-spinner>

                <b-button class="mt-3 ml-3 pull-left" variant="outline-danger" @click="hideDocModal">
                  Close
                </b-button>
              </b-modal>


              <!-- currentDateValid  v-if="row7.item.ffQuoteValidity < currentDateValid && row7.item.ffQuoteValidity!=null" -->
              <!-- <div v-else>
                  <b>N/A</b>
                </div>-->
            </template>
            <!-- <template slot="isAllActive" slot-scope="row9">
                <md-button @click="viewExportFCLConPage(row9.item.mainEnquiryId)">
                  <a class="fa fa-pencil-square-o"></a>
                </md-button>
              </template>-->
          </b-table>
        </div>

        <div>
          <h5>
            <div style="text-align: center">
              <b-pagination
                limit="5"
                align="center"
                class="mt-4"
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalRows"
                @change="onPageChange($event)"
              ></b-pagination>
            </div>
          </h5>
        </div>
      </b-card-text>
    </b-card>

    <!-- FF Starts Here -->
    <div>
      <b-modal
        no-close-on-esc
        no-close-on-backdrop
        id="myDIV"
        size="lg"
        hide-footer
        ref="dialogFF"
        title="Freight Quotation Form"
      >
        <div class="d-block text-center">
          <b-card>
            <b-card-text>
              <!-- <md-layout md-gutter>
                <md-layout md-flex="10">
                </md-layout>
                <md-layout md-flex="30"></md-layout>
                <md-layout md-flex="40">
                  <h2 style="text-align:center">Freight Quotation</h2>
                </md-layout>
                <md-layout md-flex="10"></md-layout>
                <md-button
                  class="md-fab md-primary-red"
                  v-if="mainModal.mainffId!='' && mainModal.ffStatusManager!='1' &&  mainModal.ffClientStatus!='2'"
                  @click="openPop"
                >
                  <md-icon>contact_mail</md-icon>
                </md-button>
              </md-layout>-->
              <div>
                <b-collapse id="collapseFFMain" v-model="collapseFFMainVisible">
                  <div class="box-body">
                    <div class="box-header">
                      <!-- v-if="hideButtn==false" -->
                      <!-- <md-button
                          @click="openFF"
                          class="md-raised md-primary md-button-color md-theme-default back heght-1px pull-right"
                      >New FF Quotation</md-button>-->
                    </div>
                    <table id="ff" class="table table-bordered table-striped">
                      <thead style="background: black !important">
                        <tr>
                          <th>Sr no</th>
                          <th>FF Quotation No.</th>

                          <th>Approval Status</th>

                          <th>Quotation PDF & Execution</th>
                          <th>Print</th>

                          <!-- <th>Client Name</th> -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item1, index) in ffTableArry" :key="index">
                          <td>{{ index + 1 }}</td>

                          <td
                            :style="index == 0 ? 'color:green' : 'color:red'"
                            @click="getMainFFId(item1.mainffId, 'FF')"
                          >
                            <b-button size="sm" variant="success">
                              <b>Quotation No. :</b>
                              {{ item1.mainFFSeries }}
                              <br />
                              <b>Validity Till :</b>
                              {{ item1.quotationTill == "1" ? "Handover" : "Sailing" }}
                              <br />
                              <b>Validity Date :</b>
                              {{ item1.ffvalidityDate | moment }}
                              <br />
                              <span class="error">{{
                                item1.ffExpireStatus == 1 ? " (Expired)" : ""
                              }}</span>
                            </b-button>
                          </td>
                          <td>
                            <b>Manager Approval :</b>
                            {{
                              item1.ffStatusManager == "0"
                                ? "Pending"
                                : item1.ffStatusManager == "1"
                                ? "Approved"
                                : "Rejected"
                            }}
                            <br />
                            <b>Client Approval :</b>
                            {{
                              item1.ffClientStatus == "0"
                                ? "Pending"
                                : item1.ffClientStatus == "1"
                                ? "Approved"
                                : "Rejected"
                            }}
                          </td>
                          <td
                            v-if="
                              index == '0' &&
                              item1.ffClientStatus != '2' &&
                              item1.ffClientStatus != '1'
                            "
                          >
                            <b
                              v-if="
                                item1.ffStatusManager != '1' &&
                                item1.sendHODApproveFF == '1'
                              "
                              >Sent For Approval
                              <br />
                            </b>
                            <b
                              v-else-if="
                                item1.ffStatusManager == '1' &&
                                item1.sendToEnquiryFF == '0'
                              "
                              class="showMoreData"
                              @click="openPop(item1)"
                              >Send To Enquiry Team
                              <br />
                            </b>
                            <b
                              v-else-if="
                                item1.ffStatusManager == '1' &&
                                item1.sendToEnquiryFF == '1'
                              "
                              >Already Sent to Enquiry
                              <br />
                            </b>
                            <b v-else
                              >N/A
                              <br />
                            </b>
                          </td>
                          <td v-else>
                            <b>
                              {{
                                item1.ffClientStatus == "2" && index == 0
                                  ? "Client Rejected"
                                  : item1.ffClientStatus == "1" && index == 0
                                  ? "Client Approved"
                                  : "N/A"
                              }}
                              <br />
                            </b>
                          </td>
                          <td>
                            <md-button
                              v-if="
                                item1.ffQuotationPdf != '' && item1.ffQuotationPdf != null
                              "
                              class="md-icon-button md-raised md-dense"
                              @click="Print(item1.ffQuotationPdf)"
                            >
                              <md-icon>print</md-icon>
                            </md-button>
                            <b v-else>Pdf Not Generated</b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-collapse>
              </div>
              <div>
                <b-collapse id="collapseFFChild" v-model="collapseFFChildVisible">
                  <div>
                    <b-card style="background: whiteSmoke" class="gutr">
                      <md-layout md-gutter>
                        <md-layout md-flex="25">
                          <label>Quotation Validity Date</label>
                          <date-picker
                            :format="selectDateFormat"
                            lang="en"
                            id="validityDate"
                            name="validityDate"
                            v-model="mainModal.ffvalidityDate"
                          ></date-picker>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="30">
                          <label>Quotation Validity Till</label>
                          <model-list-select
                            :list="qTillList"
                            v-model="mainModal.quotationTill"
                            option-value="qV"
                            option-text="qT"
                            placeholder="Select"
                          ></model-list-select>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="20" v-if="mainModal.sendHODApproveFF == '1'">
                          <!--  -->
                          <label for="transportType">Manager Approval</label>
                          <model-list-select
                            :list="statusList"
                            v-model="mainModal.ffStatusManager"
                            option-value="statusV"
                            option-text="statusT"
                            placeholder="Select Status"
                          ></model-list-select>
                        </md-layout>
                        <div
                          style="padding: 10px"
                          v-if="mainModal.sendHODApproveFF == '1'"
                        >
                          <!--  -->
                          <b-button
                            style="margin-top: 22px"
                            variant="primary"
                            size="sm"
                            id="addButtonLoaderM"
                            :disabled="buttonDisable"
                            @click="addGenerateQuotation('5')"
                            >Update</b-button
                          >
                        </div>
                        <md-spinner
                          md-indeterminate
                          id="loaderM"
                          style="display: none"
                        ></md-spinner>
                      </md-layout>
                    </b-card>
                  </div>
                  <div>
                    <div class="mt-3" v-if="ffShipArry.length > 0">
                      <b-button
                        size="sm"
                        class="pull-left"
                        variant="success"
                        @click="visibleMFF = !visibleMFF"
                      >
                        <span v-if="visibleMFF == true">Close</span>
                        <span v-else>New Entry</span>
                      </b-button>
                      <b-button
                        size="sm"
                        class="pull-right"
                        variant="warning"
                        v-if="
                          mainModal.mainffId != '' &&
                          mainModal.ffStatusManager != '1' &&
                          mainModal.ffClientStatus != '2' &&
                          mainModal.sendHODApproveFF != '1'
                        "
                        @click="openPop"
                        >Send For Aproval
                        <md-icon icon="envelope">email</md-icon>
                      </b-button>
                      <!-- <b-button>Button 3</b-button> -->
                    </div>

                    <!-- <b-button
                      :class="visibleMFF ? null : 'collapsed'"
                     
                    >Toggle Collapse</b-button>-->
                    <div>
                      <b-collapse id="collapseMiddle" v-model="visibleMFF" class="mt-2">
                        <div class="gutr" v-if="ffShipArry.length > 0">
                          <!-- <div class="box-header">
                      <h5 class="box-title">
                        <u>Shipping Line Details</u>
                      </h5>
                
                          </div>-->
                          <table class="table table-bordered table-striped">
                            <thead>
                              <tr>
                                <!-- <th>Sr no</th> -->
                                <th>Shipping Line</th>

                                <th>Client Approval</th>
                                <th>Action</th>

                                <!-- <th>Client Name</th> -->
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item1, index) in ffShipArry" :key="index">
                                <!-- <td>{{index+1}}</td> -->
                                <td>{{ item1.shippingLine }}</td>

                                <td>
                                  {{
                                    item1.ffClientStatus == ""
                                      ? "Pending"
                                      : item1.ffClientStatus == "1"
                                      ? "Approved"
                                      : "-"
                                  }}
                                </td>

                                <!-- <td>{{item1.clientName}}</td> -->
                                <td>
                                  <md-button
                                    class="md-icon-button md-raised md-dense"
                                    :disabled="item1.ffClientStatus == '2'"
                                    @click="editShip(item1)"
                                  >
                                    <md-icon>edit</md-icon>
                                  </md-button>
                                </td>
                              </tr>
                            </tbody>
                          </table>

                          <!-- /.box-body -->
                        </div>
                        <div>
                          <div>
                            <div
                              v-if="
                                ffShipArry.length < 3 || shipModal.ffShippingWiseId != ''
                              "
                            >
                              <div>
                                <md-layout md-gutter class="gutr">
                                  <md-layout md-flex="55">
                                    <label for="shippingId">Shipping Line Name</label>
                                    <model-list-select
                                      :isDisabled="shipModal.ffShippingWiseId != ''"
                                      :list="shippingList"
                                      v-model="shipModal.shippingId"
                                      option-value="shippingId"
                                      option-text="shippingLine"
                                      placeholder="Select Shipping Line"
                                    ></model-list-select>
                                  </md-layout>
                                  <md-layout md-flex="5"></md-layout>
                                  <md-layout md-flex="25">
                                    <label>Transit Time (No.of Days)</label>
                                    <b-form-input
                                      :formatter="capitalizeAll"
                                      id="transitTime"
                                      name="transitTime"
                                      type="number"
                                      v-model="shipModal.transitTime"
                                    ></b-form-input>
                                    <!-- <date-picker
                  placeholder="Select Time"
                  lang="en"
                  name="transitTime"
                  id="transitTime"
                  type="time"
                  format="hh:mm a"
                
                                    ></date-picker>-->
                                  </md-layout>

                                  <md-layout
                                    md-flex="10"
                                    v-if="shipModal.ffShippingWiseId != ''"
                                  >
                                    <div style="padding: 10px">
                                      <b-button
                                        size="sm"
                                        variant="info"
                                        style="margin-top: 22px"
                                        @click="clearShip"
                                        :disbaled="ffShipArry.length < 3 ? false : true"
                                        >Clear</b-button
                                      >
                                    </div>
                                  </md-layout>
                                </md-layout>
                                <md-layout md-gutter class="gutr">
                                  <md-layout md-flex="55">
                                    <label for="transportType">Container Type</label>
                                    <model-list-select
                                      :list="containerTypeList"
                                      v-model="ffModal.containerTypeId"
                                      option-value="containerTypeId"
                                      option-text="containerType"
                                      placeholder="Select Type"
                                    ></model-list-select>
                                  </md-layout>
                                </md-layout>

                                <md-layout md-gutter class="gutr">
                                  <md-layout md-flex="55">
                                    <label for="transportType">Particulars</label>
                                    <model-list-select
                                      :list="ledgerData"
                                      v-model="ffModal.ffType"
                                      option-value="ledger"
                                      option-text="ledger"
                                      placeholder="Select Type"
                                    ></model-list-select>
                                  </md-layout>
                                </md-layout>
                                <div>
                                  <b-form-checkbox
                                    id="checkbox-1"
                                    v-model="particularStatus"
                                    name="checkbox-1"
                                    value="1"
                                    unchecked-value="0"
                                    >Charges As Per Receipt</b-form-checkbox
                                  >
                                </div>
                                <md-layout
                                  md-gutter
                                  class="gutr"
                                  v-if="particularStatus == '0'"
                                >
                                  <md-layout md-flex="15">
                                    <md-layout md-flex="100">
                                      <label for="buyingRate">Buying Rate</label>

                                      <b-form-input
                                        :formatter="capitalizeAll"
                                        id="buyingRate"
                                        name="buyingRate"
                                        type="number"
                                        v-model="ffModal.buyingRate"
                                      ></b-form-input>
                                    </md-layout>
                                  </md-layout>
                                  <md-layout md-flex="5"></md-layout>

                                  <md-layout md-flex="15">
                                    <md-layout md-flex="100">
                                      <label for="sellingRate">Selling Rate</label>

                                      <b-form-input
                                        :formatter="capitalizeAll"
                                        id="sellingRate"
                                        name="sellingRate"
                                        type="number"
                                        v-model="ffModal.ffSellingRate"
                                      ></b-form-input>
                                    </md-layout>
                                  </md-layout>
                                  <md-layout md-flex="5"></md-layout>

                                  <md-layout md-flex="15">
                                    <label for="transportType">Currency</label>
                                    <model-list-select
                                      :list="currencyList"
                                      v-model="ffModal.currency"
                                      option-value="currencyV"
                                      option-text="currencyT"
                                      placeholder="Select"
                                    ></model-list-select>
                                  </md-layout>
                                </md-layout>

                                <md-layout md-gutter class="gutr">
                                  <b-button
                                    variant="primary"
                                    id="addButtonLoader1"
                                    :disabled="buttonDisable"
                                    @click="addGenerateQuotation('2')"
                                    >{{
                                      ffModal.ffQId == "" ? "Add" : "Update"
                                    }}</b-button
                                  >
                                  <md-spinner
                                    md-indeterminate
                                    id="loader1"
                                    style="display: none"
                                  ></md-spinner>
                                </md-layout>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-collapse>
                    </div>

                    <div class="box-body gutr" v-if="tempffTableArry.length > 0">
                      <table id="ff" class="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>Sr no</th>
                            <th>Shipping Line</th>
                            <th>Container Type</th>
                            <th>FF Type</th>

                            <th>Buying Rate</th>
                            <th>Selling Rate</th>
                            <th v-if="shipModal.shippingId != ''">Action</th>
                            <th>Delete</th>

                            <!-- <th>Client Name</th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item1, index) in shipModal.shippingId == ''
                              ? tempffTableArry
                              : ffLastTableArry"
                            :key="index"
                          >
                            <td>{{ index + 1 }}</td>
                            <td>{{ item1.shippingLine }}</td>
                            <td>{{ item1.containerType }}</td>
                            <td>{{ item1.ffType }}</td>

                            <td>{{ item1.buyingRate }} {{ item1.currency }}</td>
                            <td>{{ item1.ffSellingRate }} {{ item1.currency }}</td>

                            <!-- <td>{{item1.clientName}}</td> -->
                            <td v-if="shipModal.shippingId != ''">
                              <md-button
                                class="md-icon-button md-raised md-dense"
                                :disabled="item1.ffClientStatus == '2'"
                                @click="editFF(item1, index)"
                              >
                                <md-icon>edit</md-icon>
                              </md-button>
                            </td>
                            <td>
                              <md-button
                                class="md-icon-button md-raised md-dense"
                                @click="deleteTPT(item1)"
                              >
                                <md-icon>delete</md-icon>
                              </md-button>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <!-- /.box-body -->
                    </div>
                  </div>
                </b-collapse>
              </div>
            </b-card-text>
          </b-card>
        </div>

        <div>
          <b-button
            class="mt-3 pull-right"
            variant="outline-danger"
            @click="closeDialogAlertFF"
            >Cancel</b-button
          >
          <!-- <b-button class="mt-3" variant="outline-primary" @click="showQuoteDetailsPop">Show Details</b-button> -->
        </div>
      </b-modal>
    </div>
    <!-- FF Ends Here  And TPT Starts-->
    <div>
      <b-modal
        no-close-on-esc
        no-close-on-backdrop
        id="myDIV1"
        size="lg"
        hide-footer
        ref="dialogTPT"
        title="Transport Quotation Form"
      >
        <div class="d-block text-center">
          <b-card>
            <b-card-text>
              <div>
                <b-collapse id="collapseFFMain2" v-model="collapseFFMainVisibleTPT">
                  <div class="box-body">
                    <!-- <div class="box-header">
                  <h5 class="box-title">
                    <u>Existing TPT Quotations</u>
                  </h5>
                  <md-button
                    @click="openTPT"
                    v-if="hideButtn==false"
                    class="md-raised md-primary md-button-color md-theme-default back heght-1px pull-right"
                  >New TPT Quotation</md-button>
                    </div>-->
                    <table id="tpt" class="table table-striped">
                      <thead>
                        <tr>
                          <th>Sr no</th>
                          <th>TPT Quotation</th>

                          <th>Approval Status</th>

                          <th>Action</th>
                          <th>Print</th>

                          <!-- <th>Client Name</th> -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item1, index) in tptTableArry" :key="index">
                          <td>{{ index + 1 }}</td>

                          <td
                            :style="index == 0 ? 'color:green' : 'color:red'"
                            class="showMoreData"
                            @click="getMainTPTId(item1.tptQId, 'TPT')"
                          >
                            <b-button size="sm" variant="success">
                              <b>Quotation No. :</b>
                              {{ item1.tptQSeries }}
                              <br />
                              <b>Validity Date :</b>
                              {{ item1.validityDate | moment }}
                              <br />
                              <span class="error">{{
                                item1.expireStatus == 1 ? " (Expired)" : ""
                              }}</span>
                            </b-button>
                          </td>

                          <td>
                            <b>Manager Approval :</b>
                            {{
                              item1.tptStatus == "0"
                                ? "Pending"
                                : item1.tptStatus == "1"
                                ? "Approved"
                                : "Rejected"
                            }}
                            <br />
                            <b>Client Approval :</b>
                            {{
                              item1.tptClientStatus == "0"
                                ? "Pending"
                                : item1.tptClientStatus == "1"
                                ? "Approved"
                                : "Rejected"
                            }}
                          </td>

                          <!-- <td>{{item1.clientName}}</td> -->
                          <!-- <td>
                    <md-button
                      class="md-icon-button md-raised md-dense"
                      @click="editTPT(item1.tptQId)"
                    >
                      <md-icon>edit</md-icon>
                    </md-button>
                          </td>-->
                          <td
                            v-if="
                              index == '0' &&
                              item1.tptClientStatus != '2' &&
                              item1.tptClientStatus != '1'
                            "
                          >
                            <b
                              v-if="item1.tptStatus != '1' && item1.sendHODApprove == '1'"
                              >Sent For Approval
                              <br />
                            </b>
                            <b
                              v-else-if="
                                item1.tptStatus == '1' && item1.sentToEnquiry == '0'
                              "
                              class="showMoreData"
                              @click="openPop(item1)"
                              >Send To Enquiry Team
                              <br />
                            </b>
                            <b
                              v-else-if="
                                item1.tptStatus == '1' && item1.sentToEnquiry == '1'
                              "
                              >Already Sent to Enquiry Team
                              <br />
                            </b>
                            <b v-else
                              >N/A
                              <br />
                            </b>
                          </td>
                          <td v-else>
                            <b>
                              {{
                                item1.tptClientStatus == "2" && index == 0
                                  ? "Client Rejected"
                                  : item1.tptClientStatus == "1" && index == 0
                                  ? "Client Approved"
                                  : "N/A"
                              }}
                              <br />
                            </b>
                          </td>
                          <td>
                            <md-button
                              v-if="
                                item1.tptQuotationPdf != '' &&
                                item1.tptQuotationPdf != null
                              "
                              class="md-icon-button md-raised md-dense"
                              @click="Print(item1.tptQuotationPdf)"
                            >
                              <md-icon>print</md-icon>
                            </md-button>
                            <b v-else>Pdf Not Generated</b>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <!-- /.box-body -->
                  </div>
                </b-collapse>
              </div>
              <b-collapse id="collapseFFChild2" v-model="collapseFFChildVisibleTPT">
                <div>
                  <div>
                    <div>
                      <div>
                        <b-card style="background: whiteSmoke" class="gutr">
                          <md-layout md-gutter class="gutr">
                            <md-layout md-flex="75"></md-layout>
                            <md-layout md-flex="20">
                              <label>Quotation Validity Date</label>
                              <date-picker
                                :format="selectDateFormat"
                                lang="en"
                                id="validityDate"
                                name="validityDate"
                                :not-before="new Date()"
                                v-model="tptModal.validityDate"
                              ></date-picker>
                              <span class="error" v-if="!tptModal.validityDate">{{
                                errortptModal.validityDate
                              }}</span>
                            </md-layout>
                          </md-layout>
                          <md-layout md-gutter class="gutr">
                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="15">
                              <md-layout md-flex="100">
                                <label for="distance">Distance (Km)</label>

                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="distance"
                                  name="distance"
                                  type="number"
                                  v-model="tptModal.distance"
                                ></b-form-input>
                                <span class="error" v-if="!tptModal.distance">{{
                                  errortptModal.distance
                                }}</span>
                              </md-layout>
                            </md-layout>
                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="20">
                              <md-layout md-flex="100">
                                <label for="dieselRate">Diesel Allocated (Ltrs)</label>

                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="dieselRate"
                                  name="dieselRate"
                                  type="number"
                                  v-model="tptModal.dieselAllocated"
                                ></b-form-input>
                              </md-layout>
                              <!-- @keyup="finalbasecost()" -->
                            </md-layout>
                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="20">
                              <md-layout md-flex="100">
                                <label for="dieselRate">Diesel Rate (INR)</label>

                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="dieselRate"
                                  name="dieselRate"
                                  type="number"
                                  v-model="tptModal.dieselRate"
                                ></b-form-input>
                                <!-- <span class="error" v-if="!tptModal.dieselRate">{{errortptModal.dieselRate}}</span> -->
                              </md-layout>
                              <!-- @keyup="finalbasecost()" -->
                            </md-layout>
                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="20">
                              <md-layout md-flex="100">
                                <label for="mileage">Mileage</label>

                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="mileage"
                                  name="mileage"
                                  type="number"
                                  v-model="tptModal.mileage"
                                ></b-form-input>
                                <span class="error" v-if="!tptModal.mileage">{{
                                  errortptModal.mileage
                                }}</span>
                              </md-layout>
                            </md-layout>
                          </md-layout>

                          <md-layout md-gutter class="gutr">
                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="15">
                              <md-layout md-flex="100">
                                <label for="toll">Toll (INR)</label>

                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="toll"
                                  name="toll"
                                  type="number"
                                  v-model="tptModal.toll"
                                ></b-form-input>
                                <span class="error" v-if="!tptModal.toll">{{
                                  errortptModal.toll
                                }}</span>
                              </md-layout>
                            </md-layout>
                            <md-layout md-flex="5"></md-layout>
                            <md-layout md-flex="20">
                              <md-layout md-flex="100">
                                <label for="margin">Advance Cash INR)</label>

                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="margin"
                                  name="margin"
                                  type="number"
                                  v-model="tptModal.advanceCash"
                                ></b-form-input>
                                <span class="error" v-if="!tptModal.advanceCash">{{
                                  errortptModal.advanceCash
                                }}</span>
                              </md-layout>
                            </md-layout>
                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="20">
                              <md-layout md-flex="100">
                                <label for="baseCost">Base Cost (INR)</label>

                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="baseCost"
                                  name="baseCost"
                                  type="number"
                                  v-model="tptModal.baseCost"
                                ></b-form-input>
                                <span class="error" v-if="!tptModal.baseCost">{{
                                  errortptModal.baseCost
                                }}</span>
                              </md-layout>
                            </md-layout>
                            <md-layout md-flex="5"></md-layout>
                            <md-layout md-flex="20">
                              <md-layout md-flex="100">
                                <label for="quoRate"
                                  >Transportation Charges ( INR )</label
                                >
                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="quoRate"
                                  name="quoRate"
                                  type="number"
                                  v-model="tptModal.quotRate"
                                ></b-form-input>
                                <span class="error" v-if="!tptModal.quotRate">{{
                                  errortptModal.quotRate
                                }}</span>
                              </md-layout>
                            </md-layout>
                          </md-layout>

                          <md-layout
                            md-gutter
                            class="gutr"
                            v-if="tptModal.tptQId != '' && tptModal.sendHODApprove == '1'"
                          >
                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="30">
                              <label for="transportType">Quotation Status</label>
                              <model-list-select
                                :list="statusList"
                                v-model="tptModal.tptStatus"
                                option-value="statusV"
                                option-text="statusT"
                                placeholder="Select Status"
                              ></model-list-select>
                            </md-layout>
                            <md-layout md-flex="5"></md-layout>
                            <md-layout md-flex="55">
                              <md-layout md-flex="100">
                                <label for="quoRate">Remarks if Any</label>

                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="quoRate"
                                  name="quoRate"
                                  v-model="tptModal.remark"
                                ></b-form-input>
                              </md-layout>
                            </md-layout>
                          </md-layout>

                          <md-layout md-gutter class="gutr">
                            <md-layout md-flex="85"></md-layout>
                            <b-button
                              variant="primary"
                              size="sm"
                              id="addButtonLoaderAdd"
                              :disabled="buttonDisable"
                              @click="addMainTpt('5')"
                              >{{ tptModal.tptQId == "" ? "Add" : "Update" }}</b-button
                            >
                            <md-spinner
                              md-indeterminate
                              id="loaderAdd"
                              style="display: none"
                            ></md-spinner>
                          </md-layout>
                        </b-card>
                        <div class="mt-3" v-if="tptTableArryChild.length > 0">
                          <b-button
                            size="sm"
                            class="pull-left"
                            variant="success"
                            @click="visibleMTPT = !visibleMTPT"
                          >
                            <span v-if="visibleMTPT == true">Close</span>
                            <span v-else>New Entry</span>
                          </b-button>
                          <md-layout md-flex="50"></md-layout>
                          <b-button
                            size="sm"
                            class="pull-right"
                            variant="warning"
                            v-if="
                              tptModal.tptQId != '' &&
                              tptModal.tptStatus != '1' &&
                              tptModal.tptClientStatus != '2'
                            "
                            @click="openPop"
                            >Send For Aproval
                            <md-icon icon="envelope">email</md-icon>
                          </b-button>
                          <!-- <b-button>Button 3</b-button> -->
                        </div>
                      </div>

                      <div>
                        <b-collapse
                          id="collapseMiddle"
                          v-model="visibleMTPT"
                          class="mt-2"
                        >
                          <md-layout
                            md-gutter
                            class="labelMargtop"
                            v-if="tptModal.tptQId != ''"
                          >
                            <md-layout md-flex="5"></md-layout>
                            <md-layout md-flex="30">
                              <label for="transportType">Container Type</label>
                              <model-list-select
                                :list="containerTypeList"
                                v-model="tptTableModal.containerTypeId"
                                option-value="containerTypeId"
                                option-text="containerType"
                                placeholder="Select Type"
                              ></model-list-select>
                            </md-layout>
                          </md-layout>
                          <md-layout md-gutter class="gutr" v-if="tptModal.tptQId != ''">
                            <md-layout md-flex="5"></md-layout>
                            <md-layout md-flex="30">
                              <label for="transportType">Other Charges</label>
                              <model-list-select
                                :list="ledgerData"
                                v-model="tptTableModal.otherCharge"
                                option-value="ledger"
                                option-text="ledger"
                                placeholder="Select Type"
                              ></model-list-select>
                              <span class="error" v-if="!tptTableModal.otherCharge">{{
                                errortptTableModal.otherCharge
                              }}</span>
                            </md-layout>
                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="10">
                              <label for="transportType">Currency</label>
                              <model-list-select
                                :list="currencyList"
                                v-model="tptTableModal.currency"
                                option-value="currencyV"
                                option-text="currencyT"
                                placeholder="Select"
                              ></model-list-select>
                            </md-layout>
                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="15">
                              <md-layout md-flex="100">
                                <label for="sellingRate">Buy In Rate</label>

                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="sellingRate"
                                  name="sellingRate"
                                  type="number"
                                  v-model="tptTableModal.byInPrice"
                                ></b-form-input>
                                <span class="error" v-if="!tptTableModal.byInPrice">{{
                                  errortptTableModal.byInPrice
                                }}</span>
                              </md-layout>
                            </md-layout>
                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="20">
                              <md-layout md-flex="100">
                                <label for="buyingRate">Selling Rate</label>

                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="buyingRate"
                                  name="buyingRate"
                                  type="number"
                                  v-model="tptTableModal.qRate"
                                ></b-form-input>
                                <span class="error" v-if="!tptTableModal.qRate">{{
                                  errortptTableModal.qRate
                                }}</span>
                              </md-layout>
                            </md-layout>
                          </md-layout>
                          <md-layout md-gutter class="gutr" v-if="tptModal.tptQId != ''">
                            <md-layout md-flex="5"></md-layout>
                            <md-layout md-flex="30">
                              <md-layout md-flex="100">
                                <label for="freeDays">Free Days</label>
                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="freeDays"
                                  name="freeDays"
                                  type="number"
                                  v-model="tptTableModal.freeDays"
                                ></b-form-input>
                              </md-layout>
                            </md-layout>
                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="35">
                              <md-layout md-flex="100">
                                <label for="sellingRate">Remarks</label>

                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="sellingRate"
                                  name="sellingRate"
                                  v-model="tptTableModal.remark"
                                ></b-form-input>
                                <span class="error" v-if="!tptTableModal.remark">{{
                                  errortptTableModal.remark
                                }}</span>
                              </md-layout>
                            </md-layout>
                            <md-layout md-flex="5"></md-layout>
                            <b-button
                              style="margin-top: 18px"
                              v-if="tptModal.tptQId != ''"
                              variant="primary"
                              id="addButtonLoaderOth"
                              @click="addMainTpt('1')"
                              :disabled="buttonDisable"
                              >{{
                                tptTableModal.tptTableId == "" ? "Add" : "Update"
                              }}</b-button
                            >
                            <md-spinner
                              md-indeterminate
                              id="loaderOth"
                              style="display: none"
                            ></md-spinner>
                          </md-layout>
                        </b-collapse>
                      </div>
                    </div>

                    <!-- /.box-header  -->
                    <div class="box-body" v-if="tptTableArryChild.length > 0">
                      <div>
                        <div class="box-header"></div>
                        <table id="tpt" class="table table-striped">
                          <thead>
                            <tr>
                              <th>Sr no</th>
                              <th>Container Type</th>
                              <th>Other Charges</th>

                              <th>Buy In Rate</th>
                              <th>Selling Rate</th>

                              <th>Remarks</th>

                              <th>Edit</th>
                              <th>Delete</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item1, index) in tptTableArryChild" :key="index">
                              <td>{{ index + 1 }}</td>
                              <td>{{ item1.containerType }}</td>
                              <td>{{ item1.otherCharge }}</td>
                              <td>{{ item1.byInPrice }} {{ item1.currency }}</td>
                              <td>{{ item1.qRate }} {{ item1.currency }}</td>

                              <td>{{ item1.remark }}</td>

                              <!-- <td>{{item1.clientName}}</td> -->
                              <td>
                                <md-button
                                  class="md-icon-button md-raised md-dense"
                                  @click="editTPTChild(item1)"
                                >
                                  <md-icon>edit</md-icon>
                                </md-button>
                              </td>
                              <td>
                                <md-button
                                  class="md-icon-button md-raised md-dense"
                                  @click="deleteTPTOg(item1)"
                                >
                                  <md-icon>delete</md-icon>
                                </md-button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- /.box-body -->
                    </div>
                  </div>
                </div>
              </b-collapse>
            </b-card-text>
          </b-card>
        </div>

        <div>
          <b-button
            class="mt-3 pull-right"
            variant="outline-danger"
            @click="closeDialogAlertFF"
            >Cancel</b-button
          >
          <!-- <b-button class="mt-3" variant="outline-primary" @click="showQuoteDetailsPop">Show Details</b-button> -->
        </div>
      </b-modal>

      
      <b-modal
        id="EnquiryMultiUpdate-modal"
        ref="EnquiryMultiUpdate-modal"
        :title="`Change Job Type - Enq No - ${mu_enq_series} Job Type - (${multiUpdateDetail.jobType})`" 
        size="xl"
        no-close-on-esc
        no-close-on-backdrop
        hide-footer
      >
        <b-row>
          <b-col md="6"> 
            <label for="clientType">Change Client Type</label>
            <model-list-select
                class="ml-3"
                :list="clientTypeUpdateList"
                id="clientType"
                v-model="clientType"
                option-value="value"
                option-text="text"
                placeholder="Select Change Client Type" />
              
          </b-col>
          <b-col md="12">
            <b-form-group class="mt-3" label="Select Job Types">
              <div
                class="col-md-2"
                v-for="(segmentNameArray, index) in NewshowSegmentArray"
                :key="index"
                :md-flex="segmentNameArray.flex"
                md-flex-small="100"
              >
              
              <!-- @change="jobTypeSelect(segmentNameArray.value, index)" -->
                <md-checkbox
                  v-model="segmentNameArray.checked"
                  class="md-primary"
                  :md-value="segmentNameArray.value"
                  :name="'jobType' + (index + 1)"
                  :id="'jobType' + (index + 1)"
                  :disabled="segmentNameArray.disabled"
                  @change="jobTypeSelect(segmentNameArray.value, index, !segmentNameArray.checked)"
                  ><b-badge variant="light">{{
                    segmentNameArray.value
                  }}</b-badge></md-checkbox
                >
                <span class="error" v-if="newJobType.length <= 0">
                  {{ multiUpdateDetail.JobTypeError }}
                </span>
              </div>
              <span class="text-danger" v-if="multiUpdateDetail.jobType && multiUpdateDetail.jobType.length === 0">
                {{ multiUpdateDetail.JobTypeError }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="3" v-if="minusJob.indexOf('TPT') >= 0 && multiUpdateDetail.jobType && !multiUpdateDetail.jobType.includes('TPT') && !multiUpdateDetail.oldpickupLocationId">
            <label for="AutoPickupLocation">{{minusJob.indexOf("TPT") >= 0 ? "Pickup Location *" : "Pickup Location"}}</label>
            <model-list-select
              v-if="multiUpdateDetail.shipmentType == '1' && multiUpdateDetail.transportType == 'Export' && multiUpdateDetail.multipleContainerType.includes('LCL Container') && minusJob.indexOf('TPT') >= 0
              "
              :isDisabled="
                multiUpdateDetail.shipmentType == '1' &&
                multiUpdateDetail.transportType == 'Export' &&
                multiUpdateDetail.multipleContainerType.includes('LCL Container') &&
                minusJob.indexOf('TPT') >= 0
                  ? true
                  : false
              "
              id="down2"
              @input="
                getLocationList(
                  $event,
                  'Client_Factory',
                  'getAlllocationListDataFactory'
                )
              "
              @searchchange="
                getLocationList(
                  $event,
                  'Client_Factory',
                  'getAlllocationListDataFactory'
                )
              "
              :list="getAlllocationListDataFactory"
              v-model="multiUpdateDetail.pickupLocationId"
              option-value="pickupId"
              option-text="pickupLocation"
              :placeholder="
                allLocationList.length > 0
                  ? 'Select Pickup Location'
                  : 'No Pickup Location'
              "
            ></model-list-select>
            <model-list-select
              v-else-if="multiUpdateDetail.shipmentType == '1'"
              @input="
                getLocationList(
                  $event,
                  'Icd,Sea_Port_India',
                  'getAlllocationListData'
                )
              "
              @searchchange="
                getLocationList(
                  $event,
                  'Icd,Sea_Port_India',
                  'getAlllocationListData'
                )
              "
              :list="allLocationList"
              v-model="multiUpdateDetail.pickupLocationId"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select Pickup Location"
            ></model-list-select>
            <b-form-input
              :formatter="capitalizeAll"
              v-else
              id="transporterName"
              name="transporterName"
              v-model="multiUpdateDetail.airPickup"
            ></b-form-input>
            <span class="error" v-if="!multiUpdateDetail.pickupLocationId">{{
              multiUpdateDetail.pickupLocationIdError
            }}</span>
          </b-col>
          <b-col md="3" v-if="minusJob.indexOf('TPT') >= 0 && multiUpdateDetail.jobType && !multiUpdateDetail.jobType.includes('TPT') && !multiUpdateDetail.oldhandoverLocationId">
            <label for="AutoPickupLocation">{{minusJob.indexOf("TPT") >= 0 ? "Handover Location *" : "Handover Location"}}</label>
            <model-list-select
         
              id="down2"
              @input="
                getLocationList(
                  $event,
                  'Icd,Sea_Port_India',
                  'handoverListData'
                )
              "
              @searchchange="
                getLocationList(
                  $event,
                  'Icd,Sea_Port_India',
                  'handoverListData'
                )
              "
              :list="handoverListData"
              v-model="multiUpdateDetail.handoverLocationId"
              option-value="pickupId"
              option-text="pickupLocation"
               placeholder="Select Handover Location"
            ></model-list-select>
        
            <span class="error" v-if="!multiUpdateDetail.handoverLocationId">{{
              multiUpdateDetail.handoverLocationIdError
            }}</span>
          </b-col>
          <b-col md="3" v-if="minusJob.indexOf('TPT') >= 0 && multiUpdateDetail.jobType && !multiUpdateDetail.jobType.includes('TPT') && !multiUpdateDetail.oldstuffingLocationId">
            <label for="AutoPickupLocation">{{minusJob.indexOf("TPT") >= 0 ? "Factory Location *" : "Factory Location"}}</label>
            <model-list-select
         
              id="down2"
              @input="
                getLocationList(
                  $event,
                  'Client_Factory',
                  'getAlllocationListDataFactory'
                )
                multiUpdateDetail.shipmentType == '1' &&
                multiUpdateDetail.transportType == 'Export' &&
                multiUpdateDetail.multipleContainerType.includes('LCL Container') &&
                minusJob.indexOf('TPT') >= 0
                  ? FactoryPickupSame(multiUpdateDetail.stuffingLocationId)
                  : '';
              "
              @searchchange="
                getLocationList(
                  $event,
                  'Client_Factory',
                  'getAlllocationListDataFactory'
                )
              "
             :list="$store.getters['commonDropdownMaster/getAllStuffingList']"
              v-model="multiUpdateDetail.stuffingLocationId"
              option-value="pickupId"
              option-text="pickupLocation"
               placeholder="Select Factory Location"
            ></model-list-select>
        
            <span class="error" v-if="!multiUpdateDetail.stuffingLocationId">{{
              multiUpdateDetail.stuffingLocationIdError
            }}</span>
          </b-col>

          <b-col md="3" v-if="minusJob.indexOf('FF') >= 0 && multiUpdateDetail.jobType &&  !multiUpdateDetail.jobType.includes('FF') && !multiUpdateDetail.oldcontainerInfo">
            <label for="ffAc">{{minusJob.indexOf("CC") >= 0 || minusJob.indexOf("FF") >= 0 ? "FF Activity Type *" : "FF Activity Type"}}</label>
            <model-list-select          
              :list="multiUpdateDetail.shipmentType == '1'? containerInfoName : ffActivityAir"
              v-model="multiUpdateDetail.containerInfo"
              option-value="containerInfoVal"
              option-text="containerInfoText"
              placeholder="Select Activity Type"></model-list-select>
              <span class="error" v-if="!multiUpdateDetail.containerInfo">{{
              multiUpdateDetail.containerInfoError
            }}</span>
          </b-col>

          <b-col md="3" v-if="minusJob.indexOf('FF') >= 0 && multiUpdateDetail.jobType &&  !multiUpdateDetail.jobType.includes('FF') && !multiUpdateDetail.oldstuffingType">
            <label for="ffAc">{{minusJob.indexOf("CC") >= 0 || minusJob.indexOf("FF") >= 0 ? "Stuffing Type *" : "Stuffing Type"}}</label>
            <model-list-select          
              :list="stuffingTypeName"
              v-model="multiUpdateDetail.stuffingType"
              option-value="stuffingTypeVal"
              option-text="stuffingTypeText"
              placeholder="Select Stuffing Type"></model-list-select>
              <span class="error" v-if="!multiUpdateDetail.stuffingType">{{
              multiUpdateDetail.stuffingTypeError
            }}</span>
          </b-col>

          <b-col md="3" v-if="minusJob.indexOf('FF') >= 0 && multiUpdateDetail.jobType &&  !multiUpdateDetail.jobType.includes('FF') && !multiUpdateDetail.oldimporterClientId">
            <label for="ffssd">{{minusJob.indexOf("CC") >= 0 || minusJob.indexOf("FF") >= 0  ? "Importer Name *"  : "Importer Name"}}</label>
            <model-list-select          
              :list="$store.getters['common/getAllClientList']"
              v-model="multiUpdateDetail.importerClientId"
              option-value="clientId"
              option-text="clientName"
              placeholder="Select Importer Name"></model-list-select>
              <span class="error" v-if="!multiUpdateDetail.importerClientId">{{
              multiUpdateDetail.importerClientIdError
            }}</span>
          </b-col>

          <b-col md="3" v-if="minusJob.indexOf('FF') >= 0 && multiUpdateDetail.jobType &&  !multiUpdateDetail.jobType.includes('FF') && !multiUpdateDetail.oldPODLocationId">
            <label for="AutoPickupLocation">{{minusJob.indexOf("FF") >= 0 ? "Port of Discharge *" : "Port of Discharge"}}</label>
            <model-list-select
         
              id="down2"
              @input="
                 getLocationList(
                    $event,
                    multiUpdateDetail.shipmentType == '1' &&
                    multiUpdateDetail.transportType == 'Export'
                      ? 'Sea_Port_NonIndia'
                      : 'Sea_Port_India',
                    'getPortDischargeList'
                  )
              "
              @searchchange="
               getLocationList(
                $event,
                multiUpdateDetail.shipmentType == '1' &&
                multiUpdateDetail.transportType == 'Export'
                  ? 'Sea_Port_NonIndia'
                  : 'Icd,Sea_Port_India',
                'getPortDischargeList'
              )
              "
              :list="PortDischargeList"
              v-model="multiUpdateDetail.PODLocationId"
              option-value="pickupId"
              option-text="pickupLocation"
               placeholder="Select POD"
            ></model-list-select>
        
            <span class="error" v-if="!multiUpdateDetail.PODLocationId">{{
              multiUpdateDetail.PODLocationIdError
            }}</span>
          </b-col>
          <b-col md="3" v-if="minusJob.indexOf('FF') >= 0 && multiUpdateDetail.jobType &&  !multiUpdateDetail.jobType.includes('FF') && !multiUpdateDetail.oldfinalPlaceLocationId">
            <label for="AutoPickupLocation">{{minusJob.indexOf("FF") >= 0 ? "Final Place of Delivery *" : "Final Place of Delivery"}}</label>
            <model-list-select
         
              id="down2"
              @input="
                 getLocationList(
                    $event,
                    multiUpdateDetail.shipmentType == '1' &&
                    multiUpdateDetail.transportType == 'Export'
                    ? 'Sea_Port_NonIndia'
                    : 'Icd,Sea_Port_India',
                  'finalAllPlaceData'
                  )
              "
              @searchchange="
               getLocationList(
                $event,
                multiUpdateDetail.shipmentType == '1' &&
                multiUpdateDetail.transportType == 'Export'
                ? 'Sea_Port_NonIndia'
                : 'Icd,Sea_Port_India',
              'finalAllPlaceData'
              )
              "
              :list="finalAllPlaceData"
              v-model="multiUpdateDetail.finalPlaceLocationId"
              option-value="pickupId"
              option-text="pickupLocation"
               placeholder="Select FPOD"
            ></model-list-select>
        
            <span class="error" v-if="!multiUpdateDetail.finalPlaceLocationId">{{
              multiUpdateDetail.finalPlaceLocationIdError
            }}</span>
          </b-col>
          <b-col md="3" v-if="minusJob.indexOf('FF') >= 0 && multiUpdateDetail.jobType &&  !multiUpdateDetail.jobType.includes('FF') && !multiUpdateDetail.oldLPlocationId">
            <label for="AutoPickupLocation">{{minusJob.indexOf("FF") >= 0 ? "Load Port Name *" : "Load Port Name"}}</label>
            <model-list-select
         
              id="down2"
              @input="
                 getLocationList(
                    $event,
                    multiUpdateDetail.shipmentType == '1' &&
                    multiUpdateDetail.transportType == 'Export'
                      ? 'Sea_Port_India'
                      : 'Sea_Port_NonIndia',
                    'PortLoadList'
                  )
              "
              @searchchange="
                getLocationList(
                  $event,
                  multiUpdateDetail.shipmentType == '1' &&
                  multiUpdateDetail.transportType == 'Export'
                    ? 'Sea_Port_India'
                    : 'Sea_Port_NonIndia',
                  'PortLoadList'
                )
              "
              :list="PortLoadList"
              v-model="multiUpdateDetail.LPlocationId"
              option-value="pickupId"
              option-text="pickupLocation"
               placeholder="Select Load Port Name"
            ></model-list-select>
        
            <span class="error" v-if="!multiUpdateDetail.LPlocationId">{{
              multiUpdateDetail.LPlocationIdError
            }}</span>
          </b-col>

          <b-col md="3" v-if="(minusJob.indexOf('FF') >= 0 || minusJob.indexOf('CC') >= 0) && multiUpdateDetail.jobType &&  (!multiUpdateDetail.jobType.includes('FF') || !multiUpdateDetail.jobType.includes('CC')) && !multiUpdateDetail.oldPORlocationId">
            <label for="AutoPickupLocation">{{minusJob.indexOf("FF") >= 0 ? "Place of Receipt *" : "Place of Receipt"}}</label>
            {{ multiUpdateDetail.PORlocationId }}
            <model-list-select
         
              id="down2"
              @input="
                getLocationList(
                  $event,
                  multiUpdateDetail.shipmentType == '1' &&
                  multiUpdateDetail.transportType == 'Export'
                    ? 'Icd,Sea_Port_India'
                    : 'Sea_Port_NonIndia',
                  'IcdPOrtList'
                )
              "
              @searchchange="
                getLocationList(
                  $event,
                  multiUpdateDetail.shipmentType == '1' &&
                  multiUpdateDetail.transportType == 'Export'
                    ? 'Icd,Sea_Port_India'
                    : 'Sea_Port_NonIndia',
                  'IcdPOrtList'
                )
              "
              :list="IcdPOrtListNew"
              v-model="multiUpdateDetail.PORlocationId"
              option-value="pickupId"
              option-text="pickupLocation"
               placeholder="Select Place of Receipt"
            ></model-list-select>
        
            <span class="error" v-if="!multiUpdateDetail.PORlocationId">{{
              multiUpdateDetail.PORlocationIdError
            }}</span>
          </b-col>
          <b-col md="12" v-if="!isErrorsEmpty">
            <h6>Error Details</h6>
            <ul>
              <li class="error" v-for="(message, field) in multiUpdateDetailErrors" :key="field">
                <strong>{{ field }}:</strong> {{ message }}
              </li>
            </ul> 
          </b-col>
          <!-- Old Job Information -->
          <!-- <b-col md="12" class="mt-3">
            <b-form-group label="Old Job Details">
              <p v-if="allAssignmentMultiUpdateData[0]?.JobTypes">
                {{ allAssignmentMultiUpdateData[0].JobTypes }}
              </p>
              <p v-else class="text-muted">No old job data available</p>
            </b-form-group>
          </b-col> -->
        </b-row>

        <b-row class="mt-4">
          <!-- Action Buttons -->
          <b-col md="12" v-if="minusJob.length > 0">
            <b-button
              variant="primary"
              @click="updateEnquiryMultiUpdate"
              :disabled="minusJob.length <= 0"
            >
              Update
            </b-button>
            <b-button
              variant="outline-danger"
              @click="hideEnquiryMultiUpdate"
            >
              Cancel
            </b-button>
          </b-col>
        </b-row>
      </b-modal>

      <b-modal
        id="MultiUpdate-modal"
        ref="MultiUpdate-modal"
        :title="`Change Stuffing and Container - Enq No - ${mu_enq_series} Job Type - (${multiUpdateDetail.jobType})`" 
        size="xl"
        no-close-on-esc
        no-close-on-backdrop
        hide-footer
      >
        <b-row>
          <b-col cols="12" sm="6" md="3">
            <label for="stuffingLocationId">Container Type <span class="error">*</span></label>
            <model-list-select :list="$store.getters['common/getAllContainerTypeList']"
            v-model="AutoContainerType"
                    option-value="containerTypeId"
                    option-text="containerType"
                    placeholder="Select Container Type"/>
          </b-col>
          <b-col cols="12" sm="6" md="3">
            <label for="stuffingLocationId">To <span class="error">*</span></label>
            <model-list-select :list="$store.getters['commonDropdownMaster/getAllStuffingList']"
              v-model="multiUpdateDetail.stuffingLocationId" option-value="pickupId" option-text="pickupLocation"
              placeholder="Select Stuffing Location "/>
          </b-col>
          
          <b-col cols="12" sm="12" md="12" v-if="multiUpdateDetail.multipleContainerType && multiUpdateDetail.multipleContainerType.length > 0">
          <md-chip
            style="margin-top: 38px"
            md-deletable
            v-for="(type, index) in multiUpdateDetail.multipleContainerType"
            :key="index"
            @delete="deleteContainer(type)">{{ type }}</md-chip>
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col md="12">
            <b-button
              variant="primary"
              @click="updateMultiUpdate"
            >
              Update
            </b-button>
            <b-button
              variant="outline-danger"
              @click="hideMultiUpdate"
            >
              Cancel
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
      
    </div>
    <!-- TPT Ends Here -->
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop22"
    ></md-dialog-alert>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="sendMail"
      ref="popMail"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import DateRangePicker from "vue2-daterange-picker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import SingleUpload from "../common/singleUpload.vue";
import ClientUserService from "../../services/ClientUserService.js";
import FilterCBModal from "../allModuleForm/filterCBModal.vue";
import {
  lastVisitPage,
  globalPermissionStatus,
  GlobalContainerValid,
  GlobalGetLocation,
} from "../../helper/collection";
import CommonService from '../../services/CommonService.js';
import CustomLoader from "../common/customLoader.vue";
export default {
  beforeMount() {
    this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({ itemCode: "ClientList", isKYC: "Yes", isBRF: 0 })
      ),
    this.$store.dispatch(
      "commonDropdownMaster/setAllPickupDDList",
      JSON.stringify({
        itemCode: "AllPickupList",
      })
    );
    this.$store.dispatch(
      "common/setAllLeadCompList",
      JSON.stringify({
        itemCode: "GET_LeadCompLIST_Data",
      })
    );
    this.$store.dispatch(
      "common/setAllContainerTypeList",
      JSON.stringify({ itemCode: "ContainerTypeList" })
    );
    this.$store.dispatch(
      "commonDropdownMaster/setAllStuffingDDList",
      JSON.stringify({
        itemCode: "AllStuffingList",
      })
    );
    this.$store.dispatch(
      "commonDropdownMaster/setAllHandoverDDList",
      JSON.stringify({
        itemCode: "AllHandoverList",
      })
    );
    this.getServicesData();
    lastVisitPage(this.$router.history.current.fullPath);
    if (this.$sessionsStorage.get("userId") == "133") {
      this.$router.push({
        path: "/dashboard",
      });
    }
    if (globalPermissionStatus("Enquiry & Pricing")) {
      this.$store.dispatch("setCurrentRoute", "/ffExportCon/viewConsoBooking");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.viewFFExportFCL("0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      clientType:"",
      clientTypeUpdateList: [
        { value: '1', text: 'Client' },
        { value: '2', text: 'Lead' },
        { value: '3', text: 'Overseas Agent' },
      ],
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      currentDateValid: new Date().toJSON().slice(0, 10),
      finalAllPlaceDataPOR: [],
      finalAllPlaceDataPOD: [],
      finalAllPlaceDataLP: [],
      finalAllPlaceDataPickupLocation: [],

      getlocationListData: ["agra"],
      getAlllocationListData: [],
      handoverListData: [],
      getAlllocationListDataFactory: [],
      tempFactoryData: [],
      getAlllocationHandover: [],
      IcdPOrtList: [],
      AirIcdPOrtList: [],
      getPortDischargeList: [],
      PortLoadList: [],
      AirPortLoadList: [],

      finalAllPlaceData: [],
      airLineList: [],
      commodityList: [],
      airlineList: [],
      containerList: [],
      shippingList: [],

      containerInfoName: [
        {
          containerInfoVal: "fcl",
          containerInfoText: "FCL",
        },
        {
          containerInfoVal: "lcl",
          containerInfoText: "LCL",
        },
      ],
      ffActivityAir: [
        {
          containerInfoVal: "fcl",
          containerInfoText: "FCL",
        },

        {
          containerInfoVal: "FclConsolidation",
          containerInfoText: "FCL Consolidation",
        },
      ],

      documentModalSeries: "",
      documentModalEnqId: "",
      documentModalArr: [],
      validateDocumentModal: true,
      validate: true,
      documentCount: "",

      openLeft: "right",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },

      clientTypeFilter: "0",
      clientIdFilter: "",
      leadIdFilter: "",
      transportTypeFilter: "",
      shipmentTypeFilter: "",
      jobTypeFilter: "",
      enqOrExuFilter: "",
      PORfilter: "",
      PODfilter: "",
      LPfilter: "",
      PickupLocfilter: "",
      HANDfilter: "",
      STUFFfilter: "",
      commodityFilter: "",
      shippingFilter: "",
      enquiryFilter: "",
      fclLclFilter: "",
      airlineFilter: "",
      containerFilter: "",
      tptQuoteFilter: "",
      ccQuoteFilter: "",
      ffQuoteFilter: "",
      clientTypeList: [
         {
          type: "All",
          val: "0",
        },
        {
          type: "Client",
          val: "1",
        },
        {
          type: "Lead",
          val: "2",
        },
        {
          type: "Overseas Agent",
          val: "3",
        },
         {
          type: "Consignee",
          val: "4",
        },
      ],
      jTypeList: [
        {
          jTypeVal: "TPT",
          jTypeText: "TPT",
        },
        {
          jTypeVal: "FF",
          jTypeText: "FF",
        },
        {
          jTypeVal: "CC",
          jTypeText: "CC",
        },
      ],
      transportTypeName: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export",
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import",
        },
      ],
      shipmentTypeList: [
        {
          shipmentTypeVal: "1",
          shipmentTypeText: "Sea",
        },
        {
          shipmentTypeVal: "2",
          shipmentTypeText: "Air",
        },
      ],
      flTypeList: [
        {
          flVal: "fcl",
          flText: "FCL",
        },
        {
          flVal: "lcl",
          flText: "LCL",
        },
      ],

      reload: true,
      clientMaster: [],
      leadMaster: [],
      particularStatus: "0",
      name: "BootstrapVue",
      show: true,
      headerFilter: [],
      docURL: URL_BASE_DOC,
      containerNoRegexError: "",
      containerNo: "",
      validContainerNo: "",
      totalRows: 1000000000000000,
      currentPage: 1,
      perPage: 10,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filterClient: "",
      searchValPickup: "",
      searchValHandover: "",
      searchValPOR: "",
      searchValPOD: "",
      searchValLP: "",

      fields: [
        {
          key: "mainEnquiryId",
          mainkey: "mainEnquiryId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "mainEnquirySeries",
          mainkey: "mainEnquirySeries",
          label: "Enquiry No.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "clientName",
          mainkey: "clientName",
          label: "Client / Shipper Name",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "PORlocationId",
          mainkey: "PORlocationId",
          label: "Assignment Details",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },

        {
          key: "ffStatus",
          mainkey: "ffStatus",
          label: "Pricing ",
          sortable: true,
          sortDirection: "ASC",
          class: "text-center",
        },
        // {
        //   key: "mainffId",
        //   mainkey: "mainffId",
        //   label: " Quotation PDF",
        //   sortable: true,
        //   sortDirection: "ASC"
        // },
        {
          key: "ffquotation_remark",
          mainkey: "ffquotation_remark",
          label: " Quotation Remark",
          sortable: true,
          sortDirection: "ASC",
          class: "text-center",
        },
        {
          key: "tptExpired",
          mainkey: "tptExpired",
          label: " Action",
          sortable: true,
          sortDirection: "ASC",
          class: "text-center",
        },
        // {
        //   key: "isAllActive",
        //   mainkey: "isAllActive",
        //   label: "View / Edit",
        //   sortable: true,
        //   sortDirection: "ASC"
        // }
      ],
      isLoading: "",
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      consoBooking: [],

      //  FF Quote Start

      ffModal: {
        containerTypeId: "",
        mainEnquiryId: "",
        ffQId: "",
        enquiryClientId: "",
        ffType: "",
        buyingRate: "",
        ffSellingRate: "",
        shippingId: "",
        enquiryClientId: "",
        ffStatus: "",
        ffClientStatus: "",
        currency: "",
      },
      mainModal: {
        quotationTill: "",
        mainffId: "",
        mainEnquiryId: "",
        mainFFSeries: "",
        ffClientStatus: "",
        ffStatusManager: "",
        ffvalidityDate: "",
        ffExpireStatus: "",
        transitTime: "",
      },
      shipModal: {
        ffShippingWiseId: "",
        mainEnquiryId: "",
        ffQId: "",
        ffStatus: "",
        ffClientStatus: "",
        shippingId: "",
        transitTime: "",
      },
      containerTypeList: [],
      ffTypeList: [
        {
          ffTypeVal: "OceanF",
          ffTypeText: "Ocean Freight",
        },
        {
          ffTypeVal: "THC",
          ffTypeText: "THC",
        },
        {
          ffTypeVal: "BL",
          ffTypeText: "B/L",
        },
        {
          ffTypeVal: "ACD",
          ffTypeText: "ACD",
        },
        {
          ffTypeVal: "ENS",
          ffTypeText: "ENS",
        },
        {
          ffTypeVal: "SEAL",
          ffTypeText: "SEAL",
        },
        {
          ffTypeVal: "MUC",
          ffTypeText: "MUC",
        },
        {
          ffTypeVal: "OnCarriage",
          ffTypeText: "On Carriage",
        },
        {
          ffTypeVal: "DestinationTHC",
          ffTypeText: "DestinationTHC",
        },
        {
          ffTypeVal: "Destination_Documentation_Fee",
          ffTypeText: "Destination Documentation Fee",
        },
        {
          ffTypeVal: "LocalTrucking",
          ffTypeText: "Local Trucking",
        },
        {
          ffTypeVal: "ImportClearance",
          ffTypeText: "Import Clearance",
        },
        {
          ffTypeVal: "AhentHandling",
          ffTypeText: "Ahent Handling",
        },
        {
          ffTypeVal: "Line_Destination_Charges",
          ffTypeText: "Line Destination Charges",
        },
        {
          ffTypeVal: "Others",
          ffTypeText: "Others",
        },
      ],
      currencyList: [
        {
          currencyV: "INR",
          currencyT: "INR",
        },
        {
          currencyV: "USD",
          currencyT: "USD",
        },
        {
          currencyV: "EURO",
          currencyT: "EURO",
        },
        {
          currencyV: "GBP",
          currencyT: "GBP",
        },
        {
          currencyV: "ZAR",
          currencyT: "ZAR",
        },
        {
          currencyV: "CAD",
          currencyT: "CAD",
        },
        {
          currencyV: "JOD",
          currencyT: "JOD",
        },
        {
          currencyV: "AED",
          currencyT: "AED",
        },
      ],
      qTillList: [
        {
          qV: "1",
          qT: "Validity till Handover",
        },
        {
          qV: "2",
          qT: "Validity till Sailing",
        },
      ],
      statusList: [
        {
          statusV: "1",
          statusT: "Approve",
        },
        {
          statusV: "2",
          statusT: "Reject",
        },
      ],
      enqIdForFF: "",
      mainFFtableIdForFF: "",
      ENQHODMAIL: [],
      ledgerData: [],
      checkModule: [],
      enquiryArry: [],
      ffShipArry: [],
      ffTableArry: [],
      tempffTableArry: [],
      ffLastTableArry: [],
      ffMailData: [],
      ccTableArry: [],
      shippingList: [],
      collapseFFMainVisible: false,
      collapseFFMainVisibleTPT: false,
      collapseFFChildVisible: false,
      collapseFFChildVisibleTPT: false,

      ffTableArry: [],
      visibleMFF: false,
      visible: false,
      visibleMTPT: false,
      // FF Ends Here TPT Start
      tptTableArry: [],
      tptTableArryChild: [],
      tptModal: {
        baseCosting: "",
        dieselAllocated: "",
        tptQId: "",
        tptQSeries: "",
        advanceCash: "",
        mainEnquiryId: "",
        enquiryClientId: "",
        driverExp: "",
        travelDur: "",
        distance: "",
        toll: "",
        mileage: "",
        dieselRate: "",
        margin: "",
        baseCost: "",
        quotRate: "",
        tptStatus: "",
        tptClientStatus: "",
        sendHODApprove: "",
        remark: "",
        validityDate: "",
        expireStatus: "",
      },
      errortptModal: {
        advanceCash: "",
        // driverExp: "",
        //  travelDur: "",
        distance: "",
        toll: "",
        mileage: "",
        //dieselRate: "",
        // margin: "",
        baseCost: "",
        quotRate: "",

        validityDate: "",
      },
      arrayErrortptModal: {
        // driverExp: "Enter Driver Expense",
        // travelDur: "Enter Travel Duration",
        distance: "Enter Distance",
        toll: "Enter Toll",
        mileage: "Enter Mileage",
        //  dieselRate: "Enter Diesel Rate",
        //  margin: "Enter Margin",
        baseCost: "Enter Base Cost",
        quotRate: "Enter Qutotation Rate",

        validityDate: "Select Date",
      },
      mainTPTtableIdForTPT: "",
      tptTableModal: {
        containerTypeId: "",
        tptTableId: "",
        mainEnquiryId: "",
        tptQId: "",

        otherCharge: "",
        qRate: "",
        byInPrice: "",
        remark: "",
        currency: "",
        freeDays: "",
      },
      errortptTableModal: {
        otherCharge: "",
        qRate: "",
        byInPrice: "",
        remark: "",
      },
      arrayErrortptTableModal: {
        otherCharge: "Select Charges",
        qRate: "Enter quotation rate",
        byInPrice: "Enter buy price",
        remark: "Enter Remark",
      },
      stuffingTypeName: [
        {
          stuffingTypeVal: "factoryStuffing",
          stuffingTypeText: "Factory",
        },
        {
          stuffingTypeVal: "warehouseStuffing",
          stuffingTypeText: "Warehouse",
        },
      ],
      multiUpdateDetail: {
        showSegmentArray: [],
        NewshowSegmentArray: [],
        jobType: [],
        NewJobTypesArr: [],
        multipleContainerType: [],
        multipleContainerTypeId: [],
        clientId: "",
        clientType: "",
        transportType: "",
        shipmentType: "",
        containerInfo:"",
        jobType: "",
        commodityType: "",
        pickupLocationId: "",
        stuffingLocationId: "",
        handoverLocationId: "",
        importerClientId: "",
        exporterClientId: "",
        stuffingType: "",
        LPlocationId: "",
        PORlocationId: "",
        PODLocationId: "",
        finalPlaceLocationId: "",

        oldpickupLocationId: "",
        oldstuffingLocationId: "",
        oldhandoverLocationId: "",
        oldcontainerInfo:"",
        oldimporterClientId:"",
        oldstuffingType:"",

        oldLPlocationId: "",
        oldPORlocationId: "",
        oldPODLocationId: "",
        oldfinalPlaceLocationId: "",

        oldmultipleContainerType:"",
        oldmultipleContainerTypeId:"",
        
        airportDeparture: "",
        airportDestination: "",
        cargoReceived: "",
        destinationModeAir: "",

        commodityTypeError: "",
        clientIdError: "",
        clientTypeError: "",
        transportTypeError: "",
        shipmentTypeError: "",
        importerClientIdError:"",
        pickupLocationIdError: "",
        stuffingLocationIdError: "",
        handoverLocationIdError: "",
        containerInfoError: "",
        exporterClientIdError: "",
        stuffingTypeError: "",
        PORlocationIdError: "",
        LPlocationIdError: "",
        PODLocationIdError: "",
        finalPlaceLocationIdError: "",
        airportDepartureError: "",
        airportDestinationError: "",
        cargoReceivedError: "",
        destinationModeAirError: "",
      },
      AutoContainerType: {},
      NewshowSegmentArray:[],
      newJobType:[],
      mu_enq_series:"",
      mu_enq_id:"",
      minusJob:[],
      multiUpdateDetailErrors: {},
    };
  },

  created() {
    let DocURL = '';
    eventBus.$on("fileuploaded", (file) => {
      console.log("fileuploaded=>", file);
      DocURL = file;
    });
    eventBus.$on("fileuploadedindex", (fileindex) => {
      console.log("fileuploadedindex=>", fileindex);
      this.fileIndex = fileindex;
      this.documentModalArr[fileindex].doc_url = DocURL;
    });
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    Loading,
    DatePicker,
    DateRangePicker,
    ModelListSelect,
    FilterCBModal,
    SingleUpload,
    CustomLoader,
  },

  computed: {
    buttonDisable() {
      return this.mainModal.ffClientStatus == "2" || this.mainModal.ffExpireStatus == "1"
        ? true
        : false;
    },
    isErrorsEmpty() {
      return Object.values(this.multiUpdateDetailErrors).every((message) => !message);
    },
    locationList() {
      return this.getlocationListData;
    },
    IcdPOrtListNew() {
      return this.IcdPOrtList;
    },

    PortDischargeList() {
      return this.getPortDischargeList;
    },
    allLocationList() {
      return this.getAlllocationListData;
    },
    allLocationListFactory() {
      return this.getAlllocationListDataFactory;
    },
    PortList() {
      return this.getPortData;
    },
  },
  watch: {
    AutoContainerType: {
      handler: function (newVal, oldVal) {
        this.masterCallbackContainer(newVal);
      },
      deep: true,
    },
    // containerNo: {
    //   handler(newVal, oldVal) {
    //     let newCon = this.containerNo.toUpperCase();
    //     this.containerNo = newCon;
    //   },
    //   deep: true
    // }

    shipModal: {
      handler: function (newVal, oldVal) {
        if (this.shipModal.shippingId != "" && this.shipModal.ffShippingWiseId == "") {
          let arrayDum = this.ffShipArry.filter((x) => {
            return x.shippingId == this.shipModal.shippingId;
          });

          if (arrayDum.length > 0) {
            this.alert.content = arrayDum[0].shippingLine + " Already Exists";
            this.$refs["addPopAlready"].open();

            return false;
          }
        }
      },

      deep: true,
    },
  },
  methods: {
    getStuffingLocation(clientId) {

      if (clientId) {
        this.$store.dispatch(
          "commonDropdownMaster/setAllStuffingDDList",
          JSON.stringify({
            itemCode: "AllStuffingList",
            clientId: clientId,
          })
        );
      }
    },
    deleteContainer(item) {
      let i = this.multiUpdateDetail.multipleContainerType.indexOf(item);

      this.multiUpdateDetail.multipleContainerType.splice(i, 1);
      this.multiUpdateDetail.multipleContainerTypeId.splice(i, 1);
    },
    masterCallbackContainer(item) {
      console.log("item=>", item);
      console.log("this.multiUpdateDetail.multipleContainerType=>", this.multiUpdateDetail.multipleContainerType);
      if (this.multiUpdateDetail.multipleContainerType.length > 0) {
        let i = this.multiUpdateDetail.multipleContainerType.indexOf(item.containerType);

        if (i < 0) {
          this.multiUpdateDetail.multipleContainerType.push(item.containerType);
          this.multiUpdateDetail.multipleContainerTypeId.push(item.containerTypeId);
        }
      } else {
        this.multiUpdateDetail.multipleContainerType.push(item.containerType);
        this.multiUpdateDetail.multipleContainerTypeId.push(item.containerTypeId);
      }
      if (this.multiUpdateDetail.multipleContainerType.length > 0) {
        this.FactoryContainerType();
      }
    },
    FactoryContainerType() {
      if (
        this.multiUpdateDetail.shipmentType == "1" &&
        this.multiUpdateDetail.transportType == "Export" &&
        this.multiUpdateDetail.multipleContainerType[0] == "LCL Container"
      ) {
        this.multiUpdateDetail.containerInfo = "lcl";
      }
    },
    updateMultiUpdate() {
      
      // return false;
      if (this.validate != false) {
      this.isLoading = true;
      let payload = {
        assignmentNo: "MultiUpdateEnqStuff",
        mainEnquiryId:this.mu_enq_id,
        EnqNo: this.mu_enq_series,
        containerLength: this.multiUpdateDetail.multipleContainerType.length,
        multipleContainerType: this.multiUpdateDetail.multipleContainerType,
        multipleContainerTypeId: this.multiUpdateDetail.multipleContainerTypeId,
        containerInfo: this.multiUpdateDetail.containerInfo,
        stuffingLocationId: this.multiUpdateDetail.stuffingLocationId,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Common/getJobPendency.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data&& data.EnqFLAG==1) {
            this.viewFFExportFCL("0", "1", "1");
            this.isLoading = false;
            this.hideMultiUpdate();
          }
          
          this.alert.content = data.EnqMSG;
          this.$refs["popMailAfter"].open();
          this.viewFFExportFCL("0", "1", "1");
          this.isLoading = false;
        })
        .catch((error) => {});
      }
    },
    MultiUpdate(item) {
      console.log('item=>',item)
      this.multiUpdateDetail = item;
      this.mu_enq_series = item.mainEnquirySeries;
      this.mu_enq_id = item.mainEnquiryId;
      this.getStuffingLocation(item.clientId); 
      this.multiUpdateDetail.oldstuffingLocationId=item.stuffingLocationId;
      this.multiUpdateDetail.oldmultipleContainerType=item.multipleContainerType;
      this.multiUpdateDetail.oldmultipleContainerTypeId=item.multipleContainerTypeId;
      this.multiUpdateDetail.multipleContainerType=item.multipleContainerType.split(",");
      this.multiUpdateDetail.multipleContainerTypeId=item.multipleContainerTypeId.split(",");
      this.multiUpdateDetail.NewJobTypesArr = String(item.jobType).split(",");
      this.multiUpdateDetail.jobType = String(item.jobType).split(",").map(type => type.trim());

      this.$refs["MultiUpdate-modal"].show();
    },
    hideMultiUpdate() {
      this.multiUpdateDetail = {};
      this.$refs["MultiUpdate-modal"].hide();
    },
    FactoryPickupSame(stuffingLocationId) {
      this.multiUpdateDetail.pickupLocationId = stuffingLocationId;
      this.multiUpdateDetail.containerInfo = "lcl";
    },
    getDataLocations() {
      if (
        this.multiUpdateDetail.shipmentType != "" &&
        this.multiUpdateDetail.transportType != ""
      ) {
        let vehicle_drive = {
          shipmentType: this.multiUpdateDetail.shipmentType,
          transportType: this.multiUpdateDetail.transportType,
          clientType: this.multiUpdateDetail.clientType,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/getDataEnquiryLocations.php`,
          data: JSON.stringify(vehicle_drive),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.LocationDetailsTransport.length > 0) {
                this.getAlllocationListData = data.LocationDetailsTransport;
                this.handoverListData = data.LocationDetailsTransport;
              }
              if (data.LocationDetailsIcdIndiaSea.length > 0) {
                this.IcdPOrtList = data.LocationDetailsIcdIndiaSea;
              }

              if (data.LocationDetailsIndiaSea.length > 0) {
                this.PortLoadList = data.LocationDetailsIndiaSea;
              }

              if (data.LocationDetailsSeaPortsNotIndia.length > 0) {
                this.getPortDischargeList = data.LocationDetailsSeaPortsNotIndia;
                this.finalAllPlaceData = data.LocationDetailsSeaPortsNotIndia;
              }

              if (data.LocationDetailsClientFac.length > 0) {
                this.tempFactoryData = data.LocationDetailsClientFac;
                this.getAlllocationListDataFactory = data.LocationDetailsClientFac;
              
              }
              if (data.LocationDetailsAirPorts.length > 0) {
                this.AirPortLoadList = data.LocationDetailsAirPorts;
                this.AirIcdPOrtList = data.LocationDetailsAirPorts;
              }
              this.getClientFactoryLoc();
            }
          })
          .catch((error) => {});
      }
    },

    getClientFactoryLoc() {
      // alert(this.multiUpdateDetail.clientId)
      if (this.multiUpdateDetail.clientId>0) {
        console.log('this.facArry=>',this.multiUpdateDetail.clientId)
        this.$store.dispatch(
          "commonDropdownMaster/setAllStuffingDDList",
          JSON.stringify({
            itemCode: "AllStuffingList",
            clientId: this.multiUpdateDetail.clientId,
          })
        );
        // let facArry = this.tempfactoryDetail.filter((x) => {
        //   return (
        //     x.clientId == this.multiUpdateDetail.clientId && x.isMultifactoryActive == "1"
        //   );
        // });
        // console.log('this.facArry=>',facArry)
        // this.getAlllocationListDataFactory = [];
        // if (facArry.length > 0) {
        //   console.log(facArry.length);
        //   this.getAlllocationListDataFactory.unshift(...facArry);
        // }
        // console.log('this.getAlllocationListDataFactory=>',this.getAlllocationListDataFactory)

        // let obj = {
        //   pickupId: "00000",
        //   pickupLocation: "Show Other Locations",
        // };
        // this.getAlllocationListDataFactory.unshift(obj);
      
      }
    },
    EnquiryMultiUpdate(item) {
      console.log('item=>',item)
      this.clientType=item.clientType;
      this.minusJob = [];
      this.multiUpdateDetail=item;
      this.multiUpdateDetail.oldpickupLocationId=item.pickupLocationId;
      this.multiUpdateDetail.oldstuffingLocationId=item.stuffingLocationId;
      this.multiUpdateDetail.oldhandoverLocationId=item.handoverLocationId;
      
      this.multiUpdateDetail.oldstuffingType=item.stuffingType;
      this.multiUpdateDetail.oldimporterClientId=item.importerClientId;
      this.multiUpdateDetail.oldcontainerInfo=item.containerInfo;
      this.multiUpdateDetail.oldLPlocationId=item.LPlocationId;
      this.multiUpdateDetail.oldPORlocationId=item.PORlocationId;
      this.multiUpdateDetail.oldPODLocationId=item.PODLocationId;
      this.multiUpdateDetail.oldfinalPlaceLocationId= item.finalPlaceLocationId;

      this.multiUpdateDetail.showSegmentArray=[];
      this.multiUpdateDetail.NewshowSegmentArray= [];
      // this.multiUpdateDetail.jobType= [];
      this.multiUpdateDetail.NewJobTypesArr= [];
      this.multiUpdateDetail.commodityTypeError="";
      this.multiUpdateDetail.clientIdError="";
      this.multiUpdateDetail.clientTypeError="";
      this.multiUpdateDetail.transportTypeError="";
      this.multiUpdateDetail.shipmentTypeError="";
      this.multiUpdateDetail.pickupLocationIdError="";
      this.multiUpdateDetail.stuffingLocationIdError="";
      this.multiUpdateDetail.handoverLocationIdError="";
      this.multiUpdateDetail.importerClientIdError="";
      this.multiUpdateDetail.exporterClientIdError="";
      this.multiUpdateDetail.stuffingTypeError="";
      this.multiUpdateDetail.PORlocationIdError="";
      this.multiUpdateDetail.LPlocationIdError="";
      this.multiUpdateDetail.PODLocationIdError="";
      this.multiUpdateDetail.finalPlaceLocationIdError="";
      this.multiUpdateDetail.airportDepartureError="";
      this.multiUpdateDetail.airportDestinationError="";
      this.multiUpdateDetail.cargoReceivedError="";
      this.multiUpdateDetail.destinationModeAirError="";
      this.multiUpdateDetail.containerInfoError="";
      
      this.mu_enq_series = item.mainEnquirySeries;
      this.mu_enq_id = item.mainEnquiryId;
      this.NewshowSegmentArray = [];
      this.newJobType = [];
     
      // this.multiUpdateDetail.jobType = item.jobType.split(",");
      this.multiUpdateDetail.NewJobTypesArr = String(item.jobType).split(",");
      this.multiUpdateDetail.jobType = String(item.jobType).split(",").map(type => type.trim());

      // this.newJobType = item.jobType.split(",");
      this.$refs["EnquiryMultiUpdate-modal"].show();
      this.getServicesData();
      this.getDataLocations();
    },
    isJobTypeSelected(value) {
      // Check if the value exists in the jobType array
      console.log('this.multiUpdateDetail.jobType.includes(value)=>',this.multiUpdateDetail.jobType.includes(value),value)
      const index = this.multiUpdateDetail.jobType.indexOf(value);
      return index;
    },
    jobTypeSelect(selectedValue, index,isChecked) {
      this.NewshowSegmentArray[index].checked = isChecked;
      console.log("Updated Job Types:", this.newJobType);
      this.getConfirmationAlertJobChange();
    },
    validateFFExport() {

      let validate_new = true;
      this.multiUpdateDetail.commodityTypeError = "";

      if (!this.multiUpdateDetail.clientId && this.multiUpdateDetail.clientType == "1") {
        this.multiUpdateDetail.clientIdError = "Select client name";
        validate_new = false;
      }

      if (!this.multiUpdateDetail.clientType) {
        this.multiUpdateDetail.clientTypeError = "Select client type";
        validate_new = false;
      }

      if (!this.multiUpdateDetail.transportType) {
        this.multiUpdateDetail.transportTypeError = "Select Transport Type";
        validate_new = false;
      }
      if (!this.multiUpdateDetail.shipmentType) {
        this.multiUpdateDetail.shipmentTypeError = "Select Shipment Type";
        validate_new = false;
      }
     

      if (this.multiUpdateDetail.shipmentType == "1") {
        if (this.minusJob.indexOf("FF") >= 0) {
          if (!this.multiUpdateDetail.commodityType) {
            this.multiUpdateDetail.commodityTypeError = "Select Commodity Type";
            validate_new = false;
          }
        }
      } else {
        this.multiUpdateDetail.commodityTypeError = "";
      }

      if (this.multiUpdateDetail.shipmentType == "1") {
        if (
          !this.multiUpdateDetail.pickupLocationId &&
          this.minusJob.indexOf("TPT") >= 0
        ) {
          this.multiUpdateDetail.pickupLocationIdError = "Select Pickup Location";
          validate_new = false;
        }
        if (
          !this.multiUpdateDetail.stuffingLocationId &&
          this.minusJob.indexOf("TPT") >= 0
        ) {
          this.multiUpdateDetail.stuffingLocationIdError = "Select Factory  Location";
          validate_new = false;
        }

        if (
          !this.multiUpdateDetail.handoverLocationId &&
          this.minusJob.indexOf("TPT") >= 0
        ) {

          this.multiUpdateDetail.handoverLocationIdError = "Select Handover Location";
          validate_new = false;
        }
        
      }

      if (
        this.minusJob.indexOf("CC") >= 0 ||
        (this.multiUpdateDetail.shipmentType == "1" && this.minusJob.indexOf("FF") >= 0)
      ) {
        if (!this.multiUpdateDetail.containerInfo) {
          this.multiUpdateDetail.containerInfoError = "Select FF Activity";
          validate_new = false;
        }

        if (!this.multiUpdateDetail.shipmentType) {
          this.multiUpdateDetail.shipmentTypeError = "Select Shipping Type";
          validate_new = false;
        }

        if (
          !this.multiUpdateDetail.importerClientId &&
          this.multiUpdateDetail.clientType == "1"
        ) {
          this.multiUpdateDetail.importerClientIdError = "Select Importer Name";
          validate_new = false;
        }

        if (
          !this.multiUpdateDetail.exporterClientId &&
          this.multiUpdateDetail.clientType == "1"
        ) {
          this.multiUpdateDetail.exporterClientIdError = "Select Exporter Name";
          validate_new = false;
        }

        if (
          !this.multiUpdateDetail.stuffingType &&
          this.multiUpdateDetail.shipmentType == "1"
        ) {
          this.multiUpdateDetail.stuffingTypeError = "Select Stuffing Type";
          validate_new = false;
        }

        if (this.multiUpdateDetail.shipmentType == "1") {
          if (!this.multiUpdateDetail.PORlocationId) {
            this.multiUpdateDetail.PORlocationIdError = "Select Place Of Receipt";
            validate_new = false;
          }
          if (this.minusJob.indexOf("FF") >= 0) {
            if (!this.multiUpdateDetail.LPlocationId) {
              this.multiUpdateDetail.LPlocationIdError = "Select Load Port";
              validate_new = false;
            }
            if (!this.multiUpdateDetail.PODLocationId) {
              this.multiUpdateDetail.PODLocationIdError = "Select Port Of Discharge";
              validate_new = false;
            }
            if (!this.multiUpdateDetail.finalPlaceLocationId) {
              this.multiUpdateDetail.finalPlaceLocationIdError = "Select Final Place Of Delivery";
              validate_new = false;
            }
          } else {
            this.multiUpdateDetail.LPlocationIdError = "";
            this.multiUpdateDetail.PODLocationIdError = "";
            this.multiUpdateDetail.finalPlaceLocationIdError = "";
          }
        }
      }

      if (this.multiUpdateDetail.shipmentType == "2" && this.minusJob.indexOf("FF") >= 0) {
        if (!this.multiUpdateDetail.importerClientId) {
          this.multiUpdateDetail.importerClientIdError = "Select Importer Name";
          validate_new = false;
        }

        if (!this.multiUpdateDetail.exporterClientId) {
          this.multiUpdateDetail.exporterClientIdError = "Select Exporter Name";
          validate_new = false;
        }
        if (this.hideFFSection == false) {
          if (!this.multiUpdateDetail.airportDeparture) {
            this.multiUpdateDetail.airportDepartureError = "Select Airport Departure";
            validate_new = false;
          }

          if (!this.multiUpdateDetail.airportDestination) {
            this.multiUpdateDetail.airportDestinationError = "Select Airport Departure";
            validate_new = false;
          }
          if (!this.multiUpdateDetail.cargoReceived) {
            this.multiUpdateDetail.cargoReceivedError = "Select Cargo Received";
            validate_new = false;
          }

          if (!this.multiUpdateDetail.destinationModeAir) {
            this.multiUpdateDetail.destinationModeAirError = "Select Cargo Received";
            validate_new = false;
          }
        }
      }
      if (validate_new != true) {
      
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    getConfirmationAlertJobChange() {
      if (this.NewshowSegmentArray.length > 0) {
        this.minusJob = [];
        this.NewshowSegmentArray.forEach((n_ele) => {
            if (n_ele.checked) {
              this.minusJob.push(n_ele.value);
            }
        });
      }
      console.log("this.minusJob=>", this.minusJob);

    },
    getServicesData() {
      this.NewshowSegmentArray = [
        {
          value: "FF",
          show: "FREIGHT FORWARDING (FF)",
          flex: "25",
        },
        {
          value: "CC",
          show: "CUSTOM CLEARANCE (CC)",
          flex: "25",
        },
        {
          value: "TPT",
          show: "TRANSPORTATION (TPT)",
          flex: "25",
        },
      ];

      this.NewshowSegmentArray.forEach((element,index) => {
        const isChecked = this.multiUpdateDetail.jobType.includes(element.value);
          element.checked = isChecked;
          element.disabled = isChecked?true:false;
      });
      this.getConfirmationAlertJobChange();
      console.log("this.NewshowSegmentArray=>", this.NewshowSegmentArray);
    },
    updateEnquiryMultiUpdate() {
      this.multiUpdateDetail.commodityTypeError="";
      this.multiUpdateDetail.clientIdError="";
      this.multiUpdateDetail.clientTypeError="";
      this.multiUpdateDetail.transportTypeError="";
      this.multiUpdateDetail.shipmentTypeError="";
      this.multiUpdateDetail.pickupLocationIdError="";
      this.multiUpdateDetail.stuffingLocationIdError="";
      this.multiUpdateDetail.handoverLocationIdError="";
      this.multiUpdateDetail.containerInfoError="";
      this.multiUpdateDetail.importerClientIdError="";
      this.multiUpdateDetail.exporterClientIdError="";
      this.multiUpdateDetail.stuffingTypeError="";
      this.multiUpdateDetail.PORlocationIdError="";
      this.multiUpdateDetail.LPlocationIdError="";
      this.multiUpdateDetail.PODLocationIdError="";
      this.multiUpdateDetail.finalPlaceLocationIdError="";
      this.multiUpdateDetail.airportDepartureError="";
      this.multiUpdateDetail.airportDestinationError="";
      this.multiUpdateDetail.cargoReceivedError="";
      this.multiUpdateDetail.destinationModeAirError="";
      this.multiUpdateDetailErrors={};
      this.$set(this, 'multiUpdateDetailErrors', {});
    
      console.log("this.multiUpdateDetail before=>", this.multiUpdateDetail);
      console.log("this.multiUpdateDetailErrors before=>", this.multiUpdateDetailErrors);
     
      this.validateFFExport();
      // Loop through the object
      for (const key in this.multiUpdateDetail) {
          if (key.endsWith("Error") && this.multiUpdateDetail[key]) {
            this.multiUpdateDetailErrors[key] = this.multiUpdateDetail[key];
            // this.multiUpdateDetailErrors.push(this.multiUpdateDetail[key]); // Add the non-empty error messages to the array
          }
      }

      console.log("this.minusJob=>", this.minusJob);
      console.log("this.multiUpdateDetail=>", this.multiUpdateDetail);
      console.log("this.validate=>", this.validate);
      console.log("this.multiUpdateDetailErrors=>", this.multiUpdateDetailErrors);
      // return false;
      if (this.validate != false) {
      this.isLoading = true;
      let payload = {
        assignmentNo: "MultiUpdateEnq",
        mainEnquiryId:this.mu_enq_id,
        EnqNo: this.mu_enq_series,
        jobType: this.minusJob.join(","),
        LPlocationId: this.multiUpdateDetail.LPlocationId,
        PORlocationId: this.multiUpdateDetail.PORlocationId,
        PODLocationId: this.multiUpdateDetail.PODLocationId,
        finalPlaceLocationId: this.multiUpdateDetail.finalPlaceLocationId,
        handoverLocationId: this.multiUpdateDetail.handoverLocationId,
        pickupLocationId: this.multiUpdateDetail.pickupLocationId,
        stuffingLocationId: this.multiUpdateDetail.stuffingLocationId,
        clientType:this.clientType,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Common/getJobPendency.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data&& data.EnqFLAG==1) {
            
            this.isLoading = false;
            this.hideEnquiryMultiUpdate();
          }
          
          this.alert.content = data.EnqMSG;
          this.$refs["popMailAfter"].open();
          this.viewFFExportFCL("0", "1", "1");
          this.isLoading = false;
        })
        .catch((error) => {});
      }
    },
    hideEnquiryMultiUpdate() {
      this.$refs["EnquiryMultiUpdate-modal"].hide();
    },
    addPortExpenseArray() {
      let obj = {
        enq_doc_id: "",
        fk_enquiry_id: this.documentModalEnqId,
        doc_name:"",
        doc_remark: "",
        doc_url: "",
        enq_series: this.documentModalSeries,
        is_doc_active: "",
        is_doc_deleted: "",
        doc_created_date: "",
        doc_updated_date: "",

        doc_name_err: "",
        doc_url_err: "",
      };
      this.documentModalArr.push(obj);

      console.log(this.documentModalArr.length);
    },

    removeInvArry(item, index) {

      this.itemObj = item;
      this.indexNew = index;

      this.itemObj.is_doc_active = item.is_doc_active == 1 ? 0 : 1;

      let paylod = {
        tableName: "enq_doc_master",
        tableId: "enq_doc_id",
        tableIsActive: "is_doc_active",
        value1: this.itemObj.is_doc_active,
        tableVal: item.enq_doc_id,
        isMailSend: "No",
        manual: "No",
      };
      
      this.documentModalArr.splice(index, 1);

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            // this.showDocModal();
          }
        })
        .catch((error) => {
          console.log("Catch on Proforma Error: ", error);
        });
    },

    validateDocumentDetail() {
      let validate_new = true;
      let i = 0;
      let errCount = 0;
      let MainARR = this.documentModalArr;

      for (let j = 0; j < MainARR.length; j++) {
        
        if (MainARR[j].doc_name == "") {
          this.documentModalArr[j]["doc_name_err"] = "Name is Required";
          validate_new = false;
          ++errCount;
          break;
        } else {
          this.documentModalArr[j]["doc_name_err"] = "";
          validate_new = true;
        }

        if (MainARR[j].doc_url == "") {
          this.documentModalArr[j]["doc_url_err"] = "Document is Required";
          validate_new = false;
          ++errCount;
          break;
        } else {
          this.documentModalArr[j]["doc_url_err"] = "";
          validate_new = true;
        }

      }

      console.log("documentModalArr=>", this.documentModalArr);

      if (errCount > 0) {
        this.validateDocumentModal = false;
      }

      if (validate_new == false) {
        this.validateDocumentModal = false;
      } else {
        this.validateDocumentModal = true;
      }
    },

    addDocumentDetail() {

      this.validateDocumentDetail();
      console.log("array doc -> ", this.documentModalArr);

      let payload = {
        itemCode: "add_enquiry_document",
        documentDetails: this.documentModalArr,
      };

      if (this.validateDocumentModal != false) {
        this.isLoading = true;
        CommonService.getAllDocumentList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
              this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on document upload Error: ", error);
          });
      }
    },
    
    showDocModal(item) {
      this.documentModalSeries = "";
      this.documentModalEnqId = "";
      this.documentModalSeries = item.mainEnquirySeries;
      this.documentModalEnqId = item.mainEnquiryId;
      // this.isLoading = true;

      let payload = {
        itemCode: "get_enquiry_document",
        enquiryId: this.documentModalEnqId,
      };

      CommonService.getAllDocumentList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          
          this.isLoading = false;
          this.documentCount =  data.documentDetailsList.length;

          if(data.documentDetailsList.length > 0){
            this.documentModalArr = data.documentDetailsList;
          }

        })
        .catch((error) => {
          console.log("Catch on document upload Error: ", error);
        });

      console.log(this.documentModalSeries);
      console.log(this.documentModalEnqId);

      this.$refs["doc-modal"].show();
    },

    hideDocModal() {
      this.documentModalArr = [];
      this.$refs["doc-modal"].hide();
    },

    viewAllQuotationLibrary() {
      this.$router.push({
        path: "/allQuotationLib",
      });
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewFFExportFCL(CURRENT, "2", event);
    },
    filterSearch() {
      this.reload = false;
      this.viewFFExportFCL("0", "1", "1");
    },
    clearFilter() {
      this.shippingFilter = "";
      this.tptQuoteFilter = "";
      this.ccQuoteFilter = "";
      this.ffQuoteFilter = "";
      this.enquiryFilter = "";
      this.fclLclFilter = "";
      this.airlineFilter = "";
      this.containerFilter = "";
      this.clientIdFilter = "";
      this.leadIdFilter = "",
      this.transportTypeFilter = "";
      this.shipmentTypeFilter = "";
      this.clientTypeFilter="0";

      this.PORfilter = "";
      this.PODfilter = "";
      this.LPfilter = "";
      this.PickupLocfilter = "";
      // PickupLocfilter: "",
      this.HANDfilter = "";
      this.STUFFfilter = "";
      this.viewFFExportFCL("0", "1", "1");
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };

      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    // FF Starts Here
    deleteTPT(item) {
      let paylod = {
        tableName: "mainffquotation",
        tableId: "ffQId",
        tableVal: item.ffQId,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/deletePermanent.php`,
        data: JSON.stringify(paylod),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.getData();
          }
        })
        .catch((error) => {});
    },
    openPop() {
      this.alert.content = "Send Mail To HOD for Approval..?";
      this.$refs["popMail"].open();
    },
    sendMail(type) {
      if (type != "cancel") {
        this.isLoading = true;
        let list = [];

        this.tempffTableArry.map((x) => {
          let i = list.indexOf(x.ffType);
          if (i < 0) {
            list.push(x.ffType);
          }
        });

        let newList = [];
        list.map((x) => {
          let obj = {
            type: x,
          };

          this.ffShipArry.map((y, index) => {
            let array1 = this.tempffTableArry.filter((z) => {
              return z.ffShippingWiseId == y.ffShippingWiseId && z.ffType == x;
            });

            if (array1.length > 0) {
              obj["s" + (index + 1)] = array1[0].ffSellingRate;
              obj["b" + (index + 1)] = array1[0].buyingRate;
              obj["conType"] = array1[0].containerType;
              obj["currency" + (index + 1)] = array1[0].currency;
            } else {
              obj["s" + (index + 1)] = "-";
              obj["b" + (index + 1)] = "-";
              obj["conType"] = "";
              obj["currency" + (index + 1)] = "";
            }
          });

          newList.push(obj);
        });

        let newData = {
          mainffId: this.mainFFtableIdForFF,
          mainEnquiryId: this.enqIdForFF,
          jobType: "FF",
          MainFFQ: this.ffMailData[0],
          MainFFShip: this.ffShipArry,
          MainFFtable: this.tempffTableArry,
          MainEnq: this.enquiryArry[0],
          table: newList,
          hodMails: this.ENQHODMAIL,
        };

        if (this.validate != false) {
          $("#addButtonLoaderS").css("display", "none");
          $("#loaderS").css("display", "block");

          let options = {
            method: "POST",
            url: `${URL_BASE}/Enquiry/sendForApprovalTPT_VP.php`,
            data: JSON.stringify(newData),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              $("#loaderS").css("display", "none");
              $("#addButtonLoaderS").css("display", "block");
              this.isLoading = false;
              this.alert.content = "Mail Sent";
              this.$refs["popMailAfter"].open();
              this.$router.push({
                path: "/mainEnquiry/viewMainEnqQuotationFF",
              });
            })
            .catch((error) => {});
        }
      }
    },
    clearShip() {
      Object.keys(this.shipModal).map((x) => {
        this.shipModal[x] = "";
      });
      Object.keys(this.ffModal).map((x) => {
        this.ffModal[x] = "";
      });
      this.ffLastTableArry = [];
    },
    addGenerateQuotation(ID) {
      if (this.particularStatus == 1) {
        this.ffModal.buyingRate = "Rates Applicable as per receipt";
        this.ffModal.ffSellingRate = "Rates Applicable as per receipt";
      }

      this.mainModal["mainEnquiryId"] = this.enqIdForFF;
      this.mainModal["mainffId"] = this.mainFFtableIdForFF;
      this.shipModal["mainEnquiryId"] = this.enqIdForFF;
      this.shipModal["mainffId"] = this.mainFFtableIdForFF;
      this.ffModal["mainEnquiryId"] = this.enqIdForFF;
      this.ffModal["mainffId"] = this.mainFFtableIdForFF;

      let newData = {
        FFModal: this.ffModal,
        mainModal: this.mainModal,
        shipModal: this.shipModal,
        buttonId: ID,
      };

      if (this.validate != false) {
        if (ID == "2") {
          $("#addButtonLoader1").css("display", "none");
          $("#loader1").css("display", "block");
        }
        if (ID == "5") {
          $("#addButtonLoaderM").css("display", "none");
          $("#loaderM").css("display", "block");
        }

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/addMainFFQuotation.php`,
          data: JSON.stringify(newData),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            if (ID == "2") {
              $("#loader1").css("display", "none");
              $("#addButtonLoader1").css("display", "block");
            }

            if (ID == "5") {
              $("#loaderM").css("display", "none");
              $("#addButtonLoaderM").css("display", "block");
            }
            if (this.mainFFtableIdForFF == "") {
              this.mainFFtableIdForFF = data.mainffId;
              this.shipModal.ffShippingWiseId = data.dataQuotation[0].ffShippingWiseId;
            }
            if (this.ffModal.ffQId == "") {
              this.ffLastTableArry.push(data.dataQuotation[0]);
            } else {
              this.ffLastTableArry[this.index1] = this.ffModal;
            }

            if (this.shipModal.ffShippingWiseId == "") {
              Object.keys(this.shipModal).map((x) => {
                this.shipModal[x] = "";
              });
              Object.keys(this.ffModal).map((x) => {
                this.ffModal[x] = "";
              });
            }

            // this.getDataFFQMainTable();
            //  this.getDataFFQ(BTNID);
            // this.getData();
          })
          .catch((error) => {});
      }
    },
    editShip(ID) {
      Object.keys(this.shipModal).map((x) => {
        this.shipModal[x] = ID[x];
      });
      let array = this.tempffTableArry.filter((x) => {
        return x.ffShippingWiseId == ID.ffShippingWiseId;
      });

      if (array.length > 0) {
        this.ffLastTableArry = array;
      } else {
        this.ffLastTableArry = [];
      }
    },
    editFF(item, index) {
      Object.keys(this.ffModal).map((x) => {
        this.ffModal[x] = item[x];
      });
      this.index1 = index;
      this.visibleMFF = true;
    },

    getDataFFQ(BTNID) {
      let buttonId = BTNID;
      this.isLoading = true;
      let payload = {
        assignmentNo: "assignmentNo",
        mainEnquiryId:
          this.enqIdForFF != "" || this.enqIdForFF != undefined ? this.enqIdForFF : "",

        mainffId:
          this.mainFFtableIdForFF != "" || this.mainFFtableIdForFF != undefined
            ? this.mainFFtableIdForFF
            : "",
        tptQId:
          this.mainTPTtableIdForTPT != "" || this.mainTPTtableIdForTPT != undefined
            ? this.mainTPTtableIdForTPT
            : "",
        ffShippingWiseId:
          this.$sessionsStorage.get("editffShipId") != "" ||
          this.$sessionsStorage.get("editffShipId") != undefined
            ? this.$sessionsStorage.get("editffShipId")
            : "",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/getDataMainQuot.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.enquiryData.length > 0) {
              this.enquiryArry = data.enquiryData;
              this.tptModal.enquiryClientId = data.enquiryData[0].clientId;
              // if (data.enquiryData.length == 1) {
              //   this.collapseFFChildVisible = true;
              // }
              // this.checkModule = data.enquiryData[0].jobType.split(",");
            } else {
              this.enquiryArry = [];
            }

            if (data.ledgerData.length > 0) {
              this.ledgerData = data.ledgerData;
            } else {
              this.ledgerData = [];
            }

            if (data.ENQHODMAIL.length > 0) {
              this.ENQHODMAIL = data.ENQHODMAIL;
            } else {
              this.ENQHODMAIL = [];
            }

            if (data.containerMaster.length > 0) {
              this.containerTypeList = data.containerMaster;
            } else {
              this.containerTypeList = [];
            }

            if (data.slineDetails.length > 0) {
              this.shippingList = data.slineDetails;
            }

            if (data.ffData.length > 0) {
              this.ffTableArry = data.ffData;
              if (buttonId == "FF") {
                this.collapseFFMainVisible = true;
              }

              // if (data.ffData.length == 1) {
              //   this.mainFFtableIdForFF = data.ffData[0].mainffId;
              // }

              // let arryStatus = this.ffTableArry.filter(x => {
              //   return x.ffClientStatus == "1";
              // });

              // if (arryStatus.length > 0) {
              //   // this.hideButtn = true;
              // }

              // let arryExpire = this.ffTableArry.filter(x => {
              //   return x.ffExpireStatus == "0" && x.ffClientStatus == "2";
              // });

              // if (arryExpire.length > 0) {

              //   this.hideButtn = false;
              // }
            } else {
              this.ffTableArry = [];
              if (buttonId == "FF") {
                this.collapseFFChildVisible = true;
                this.visibleMFF = true;
              }
            }

            if (data.fflastDataStatus.length > 0) {
              this.ffMailData = data.fflastDataStatus;
              Object.keys(data.fflastDataStatus[0]).map((x) => {
                this.mainModal[x] = data.fflastDataStatus[0][x] || "";
              });

              this.mainModal.ffClientStatus = data.fflastDataStatus[0].ffClientStatus;
            }

            if (data.ffShipData.length > 0) {
              this.ffShipArry = data.ffShipData;
              if (buttonId == "FF") {
                this.collapseFFChildVisible = true;
              }
            } else {
              this.ffShipArry = [];
            }
            if (data.fflastData.length > 0) {
              this.tempffTableArry = data.fflastData;
            }

            if (data.tptData.length > 0) {
              this.tptTableArry = data.tptData;
              if (buttonId == "TPT") {
                this.collapseFFMainVisibleTPT = true;
              }
              // let arryStatus = this.tptTableArry.filter(x => {
              //   return x.tptClientStatus == "1";
              // });

              // if (arryStatus.length > 0) {
              //   this.hideButtn = true;
              // }

              // let arryExpire = this.tptTableArry.filter(x => {
              //   return x.expireStatus == "0" || x.tptClientStatus == "2";
              // });

              // if (arryExpire.length > 0) {

              //   this.hideButtn = false;
              // }
            } else {
              this.tptTableArry = [];
              if (buttonId == "TPT") {
                this.collapseFFChildVisibleTPT = true;
              }
            }
            // TPT
            console.log(data);

            if (data.tptMain.length > 0) {
              Object.keys(data.tptMain[0]).map((x) => {
                this.tptModal[x] = data.tptMain[0][x] || "";
              });
              if (buttonId == "TPT") {
                this.collapseFFChildVisibleTPT = true;
              }
            } else {
              this.tptModal.distance = data.distancegps;
            }
            if (data.tptTableData.length > 0) {
              this.tptTableArryChild = data.tptTableData;
            } else {
              this.tptTableArryChild = [];
            }

            if (buttonId == "FF") {
              this.$refs["dialogFF"].show();
            } else {
              this.$refs["dialogTPT"].show();
            }
            console.log(
              this.collapseFFMainVisible,
              "FF",
              this.collapseFFChildVisible,
              "TPT",
              this.collapseFFMainVisibleTPT,
              this.collapseFFChildVisibleTPT
            );
            this.isLoading = false;
            // this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
    // getDataFFQMainTable() {
    //   //  this.isLoading = true;
    //   let payload = {
    //     assignmentNo: "assignmentNo",
    //     mainEnquiryId:
    //       this.enqIdForFF != "" || this.enqIdForFF != undefined
    //         ? this.enqIdForFF
    //         : ""
    //   };
    //   let options = {
    //     method: "POST",
    //     url: `${URL_BASE}/getDataMainQuot.php`,
    //     data: JSON.stringify(payload),
    //     crossDomain: true,
    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: this.$sessionsStorage.get("loginId")
    //     }
    //   };
    //   axios(options)
    //     .then(result => {
    //       const { statusText, status, data } = result;
    //       if ( status == 200 && data) {
    //
    //         if (data.enquiryData.length > 0) {
    //           this.enquiryArry = data.enquiryData;
    //           this.collapseFFMainVisible = true;
    //           //  this.checkModule = data.enquiryData[0].jobType.split(",");
    //         } else {
    //           this.enquiryArry = [];
    //         }

    //         if (data.ffData.length > 0) {
    //           this.ffTableArry = data.ffData;

    //           let arryStatus = this.ffTableArry.filter(x => {
    //             return x.ffClientStatus == "1";
    //           });

    //           if (arryStatus.length > 0) {
    //             // this.hideButtn = true;
    //           }

    //           // let arryExpire = this.ffTableArry.filter(x => {
    //           //   return x.ffExpireStatus == "0" && x.ffClientStatus == "2";
    //           // });

    //           // if (arryExpire.length > 0) {
    //
    //           //   this.hideButtn = false;
    //           // }
    //         } else {
    //           this.ffTableArry = [];
    //         }

    //         // this.isLoading = false;
    //         // this.JqueryFun();
    //       }
    //     })
    //     .catch(error => {});
    // },

    getMainFFId(MAINFFID, BTNID) {
      this.mainFFtableIdForFF = MAINFFID;

      // this.getDataFFQ(BTNID);
    },
    getMainTPTId(MAINTPTID, BTNID) {
      this.mainTPTtableIdForTPT = MAINTPTID;

      //  this.getDataFFQ(BTNID);
    },

    openDialogAlertFF(ENQIDFF, BTNID) {
      this.enqIdForFF = ENQIDFF;
      // this.getDataFFQMainTable();
      //  this.getDataFFQ(BTNID);
    },
    closeDialogAlertFF() {
      this.ffShipArry = [];
      this.ffTableArry = [];
      this.collapseFFMainVisible = false;
      this.collapseFFMainVisibleTPT = false;
      this.collapseFFChildVisible = false;
      this.collapseFFChildVisibleTPT = false;
      this.tempffTableArry = [];
      this.visibleMFF = false;
      this.visibleTPT = false;
      this.$refs["dialogFF"].hide();
      this.tptTableArryChild = [];
      this.tptTableArry = [];
      this.$refs["dialogTPT"].hide();
    },
    //FF End Here TPT Start
    validateTPTQuotation(ID) {
      let validateNew = true;

      if (ID == "5") {
        Object.keys(this.errortptModal).map((x) => {
          if (this.tptModal[x] == "") {
            this.errortptModal[x] = this.arrayErrortptModal[x] || "";
            validateNew = false;
          } else {
            this.errortptModal[x] = "";
          }
        });
      }

      if (ID == "1") {
        Object.keys(this.errortptTableModal).map((x) => {
          if (this.tptTableModal[x] == "") {
            this.errortptTableModal[x] = this.arrayErrortptTableModal[x] || "";
            validateNew = false;
          } else {
            this.errortptTableModal[x] = "";
          }
        });
      }

      if (validateNew) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    addMainTpt(ID) {
      // this.validateFFExport();

      this.tptModal["mainEnquiryId"] = this.enqIdForFF;
      this.tptTableModal["mainEnquiryId"] = this.enqIdForFF;

      //  this.tptModal["tptQId"] = this.$sessionsStorage.get("editTPTQId");
      this.tptTableModal["tptQId"] = this.mainTPTtableIdForTPT;

      let newData = {
        TPTModal: this.tptModal,
        mainModal: this.tptTableModal,
        buttonId: ID,
      };

      this.validateTPTQuotation(ID);

      if (this.validate != false) {
        if (ID == "5") {
          $("#addButtonLoaderAdd").css("display", "none");
          $("#loaderAdd").css("display", "block");
        }
        if (ID == "1") {
          $("#addButtonLoaderOth").css("display", "none");
          $("#loaderOth").css("display", "block");
        }

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/addMainTPTQuotation.php`,
          data: JSON.stringify(newData),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            if (this.mainTPTtableIdForTPT == "") {
              this.mainTPTtableIdForTPT = data.tptQId;
            }

            if (ID == "5") {
              $("#loaderAdd").css("display", "none");
              $("#addButtonLoaderAdd").css("display", "block");
            }
            if (ID == "1") {
              $("#loaderOth").css("display", "none");
              $("#addButtonLoaderOth").css("display", "block");
              // Object.keys(this.tptTableModal).map(x => {
              //   this.tptTableModal[x] = "";
              // });
            }
            //this.getDataFFQ("TPT");
          })
          .catch((error) => {});
      }
    },
    editTPTChild(item) {
      Object.keys(this.tptTableModal).map((x) => {
        this.tptTableModal[x] = item[x];
      });
    },

    deleteTPTOg(item) {
      let paylod = {
        tableName: "maintptqtable",
        tableId: "tptTableId",
        tableVal: item.tptTableId,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/deletePermanent.php`,
        data: JSON.stringify(paylod),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.getData();
          }
        })
        .catch((error) => {});
    },

    // TPT Ends Hers
    containerNoRegexfun() {
      this.getCommodityList();
      // alert();
      let lastDigitReturn = this.validContainerNo.slice(this.validContainerNo.length - 7);
      let lastDigitCon = this.containerNo.slice(this.containerNo.length - 7);

      var containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");
      // var re = new RegExp("/\b" + test + "\b/");
      if (containerformat.test(this.containerNo) && lastDigitCon == lastDigitReturn) {
        this.containerNoRegexError = "";
      } else {
        this.containerNoRegexError = "Enter Valid Format";
      }
    },
    getCommodityList() {
      //let self = this;

      if (this.containerNo != "") {
        this.validContainerNo = GlobalContainerValid(this.containerNo);
        //  alert(this.validContainerNo);
      }
    },
    Print2(item) {
      if(!item) return;
      this.openSignedDocument(`TPT_QUOTATION_PDF/${item}`);
    },
    Print1(item) {
      if(!item) return;
      this.openSignedDocument(`CC_QUOTATION_PDF/${item}`);
    },
    PrintConso(item) {
      if(!item) return;
      this.openSignedDocument(`EnqMergeClientPdf/${item}`);
    },

    Print(item) {
      if(!item) return;
      this.openSignedDocument(`FF_QUOTATION_PDF/${item}`);
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewFFExportFCL(CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },
    goToMain() {
      this.$sessionsStorage.set("editMainEnqId", "");
      this.$router.push({
        path: "/mainEnquiry/mainEnquiry",
      });
    },
    JqueryFun() {
      return $(function () {
        return $("#conBooking").DataTable({
          // bStateSave: true
        });
      });
    },

    viewExportFCLConPage(AM) {
      if (
        this.$sessionsStorage.get("finalPagePermision").split(",").indexOf("Enquiry") >= 0
      ) {
        this.$sessionsStorage.set("editMainEnqId", AM);

        this.$router.push({
          path: "/mainEnquiry/mainEnquiry",
        });
      }
    },
    goToQuo(item,id) {
      this.$sessionsStorage.set("editMainEnqId", id);
      let shipmentType='Sea';
      if(item.shipmentType==2){
        shipmentType='Air'
      }
      this.$router.push({
        path: "/mainEnquiry/mainEnqQuotation?JobType=TPT&ShipmentType="+shipmentType+"&ModuleType="+item.transportType,
      });
    },

    goToMisc() {
      this.$sessionsStorage.set("editSalesExId", "");
      this.$router.push({
        path: "/mainEnquiry/miscSalesExecutionAll",
      });
    },

    goToExe(IDSales) {
      let FFValid = "";
      let CCValid = "";
      let TPTValid = "";
      // alert(IDSales.ffQuoteValidity)
      if (
        IDSales.ffQuoteValidity < this.currentDateValid ||
        IDSales.ffClientStatus != 1
      ) {
        FFValid = false;
      } else {
        FFValid = true;
      }
      if (
        IDSales.ccQuoteValidity < this.currentDateValid ||
        IDSales.ccClientStatus != 1
      ) {
        CCValid = false;
      } else {
        CCValid = true;
      }
      if (
        IDSales.tptQuoteValidity < this.currentDateValid ||
        IDSales.tptClientStatus != 1
      ) {
        TPTValid = false;
      } else {
        TPTValid = true;
      }
      // TPTValid = false;
      // alert(IDSales.tptClientStatus)
      // alert(IDSales.tptQuoteValidity)
      // alert(this.currentDateValid)
      // alert(TPTValid)
      // return false;
      this.$sessionsStorage.set("editMainEnqId", IDSales.mainEnquiryId);
      this.$sessionsStorage.set("isFFValid", FFValid);
      this.$sessionsStorage.set("isCCValid", CCValid);
      this.$sessionsStorage.set("isTPTValid", TPTValid);
      this.$sessionsStorage.set("editSalesExId", "");
      this.$router.push({
        path: "/mainEnquiry/salesExecutionAll",
      });
    },

    goToFF(item,id) {
      console.log('item+.',item)
      this.$sessionsStorage.set("editMainEnqId", id);
      let shipmentType='Sea';
      if(item.shipmentType==2){
        shipmentType='Air'
      }
      this.$router.push({
        path: "/mainEnquiry/mainEnqQuotationFF?JobType=FF&ShipmentType="+shipmentType+"&ModuleType="+item.transportType,
      });
    },
    goToCC(item,id) {
      this.$sessionsStorage.set("editMainEnqId", id);
      let shipmentType='Sea';
      if(item.shipmentType==2){
        shipmentType='Air'
      }
      this.$router.push({
        path: "/mainEnquiry/mainEnqQuotationCC?JobType=CC&ShipmentType="+shipmentType+"&ModuleType="+item.transportType,
      });
    },
    viewFFExportFCL(CURRENT, SEARCH, pageNumber) {
      if(!this.enquiryFilter){
        this.enquiryFilter=this.$sessionsStorage.get("editMainFilterEnqId")?this.$sessionsStorage.get("editMainFilterEnqId"):"";
      }
      this.$sessionsStorage.set("editMainFilterEnqId","");
      this.isLoading = true;
      let payload = {
        clientTypeFilter: this.clientTypeFilter,
        clientId: this.clientIdFilter,
        leadId: this.leadIdFilter,
        shipmentType: this.shipmentTypeFilter,
        transportType: this.transportTypeFilter,
        PORfilter: this.PORfilter,
        PODfilter: this.PODfilter,
        LPfilter: this.LPfilter,
        PickupLocfilter: this.PickupLocfilter,
        HANDfilter: this.HANDfilter,
        STUFFfilter: this.STUFFfilter,
        shippingFilter: this.shippingFilter,
        enquiryFilter:this.enquiryFilter,
        fclLclFilter: this.fclLclFilter,
        airlineFilter: this.airlineFilter,
        containerFilter: this.containerFilter,
        tptQuoteFilter: this.tptQuoteFilter,
        ccQuoteFilter: this.ccQuoteFilter,
        ffQuoteFilter: this.ffQuoteFilter,
        fields: this.fields,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        assignmentNo: "assignmentNo",
        dateRange: this.dateRange,
      };
      console.log("Enquiry payload => ", payload); 
      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/viewMainEnqDetails.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.totalRows = data.totalData;
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }

            // toUpper = function(x) {
            //   return x.toUpperCase();
            // };

            if (data.mainEnqData.length > 0) {
              // let arryLower = data.mainEnqData.map(toUpper);
              this.consoBooking = data.mainEnqData;
            } else {
              this.consoBooking = [];
            }
            this.isLoading = false;
            if (this.reload == true) {
              if (data.LocationDetailsFinal.length > 0) {
                this.finalAllPlaceDataPOR = data.LocationDetailsFinal;
                this.finalAllPlaceDataPOD = data.LocationDetailsFinal;
                this.finalAllPlaceDataLP = data.LocationDetailsFinal;
              }
              if (data.LocationDetailsTransport.length > 0) {
                this.finalAllPlaceDataPickupLocation = data.LocationDetailsTransport;
              }
              if (data.shippingList.length > 0) {
                this.shippingList = data.shippingList;
              }
              if (data.airlineList.length > 0) {
                this.airlineList = data.airlineList;
              }
              if (data.containerList.length > 0) {
                this.containerList = data.containerList;
              }
              if (data.clientMaster.length > 0) {
                this.clientMaster = data.clientMaster;
              }
            }
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style scoped>
.appMargin0 {
  margin-left: 0px !important;
  margin-right: 100px;
  transition: 5s !important;
}
.modal fade show d-block {
  background: none;
}

.btn-outline-success {
  margin-bottom: 0.5rem;
}
.btn-outline-danger {
  margin-bottom: 0.5rem;
}
@media (max-width: 944px) {
  .md-flex-small-100 {
    margin-top: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// viewMainEnquiryDetails.vue?0d985967